/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * TeacherBook API - Teacher daily planner with compliance documentation
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AddStudentToClassBody,
  AiFeedback201,
  AiFeedbackBody,
  AiLessonPrep200,
  AiLessonPrepBody,
  AiNccdPolishText200,
  AiNccdPolishTextBody,
  AiPolishText200,
  AiPolishTextBody,
  AnalyticsSummary,
  ArchiveBody,
  ArchiveTimetableInput,
  CalendarEvent,
  CalendarEventInput,
  Class,
  ClassDependentsCount,
  ClassInput,
  ClassPrefsInput,
  ConfirmMergeInput,
  CopyTimetableResult,
  Course,
  CourseDependentsCount,
  CourseInput,
  CoursePrefsInput,
  CreateMarkbookAssessmentInput,
  CreateSchoolGroupInput,
  DailyOverride,
  DailyOverrideError,
  DailyOverrideInput,
  DailyOverrideResponse,
  DeleteAdminUser200,
  DeleteProfile200,
  DeleteProfileBody,
  DeleteSchoolCode200,
  DiaryEntry,
  DiarySlotInput,
  DownloadLessonsHtmlParams,
  DownloadRecordsCsvParams,
  DownloadSentralNccdLogCsvParams,
  DownloadSentralNccdSummaryCsvParams,
  ErrorEnvelope,
  Export,
  ExportInput,
  GetDiaryEntriesParams,
  GetMarkbookParams,
  GetPatternsParams,
  HealthStatus,
  ListCalendarEventsParams,
  ListClassesParams,
  ListCoursesParams,
  ListDailyOverridesParams,
  ListMarkbookClassesParams,
  ListRecordsParams,
  ListStudentsParams,
  MarkbookAssessment,
  MarkbookMark,
  MarkbookView,
  MergeSuggestionsResponse,
  Notes,
  OkResponse,
  PatternsReport,
  PreviewExport200,
  PreviewExportParams,
  PreviewLessonsExport200,
  PreviewLessonsExportParams,
  Profile,
  ProfileInput,
  Record,
  RecordInput,
  ReorderInput,
  RestoreAccount200,
  RestoreAccountBody,
  SaveDiaryDayNotesBody,
  SaveTimetableSlotsBody,
  SchoolAggregatedAnalytics,
  SchoolFreshStartInput,
  SchoolFreshStartResult,
  SchoolGroup,
  SchoolGroupMembersResult,
  SchoolMergeLogEntry,
  SchoolOverview,
  SchoolStructureImportInput,
  SchoolStructureImportResult,
  SchoolTeacherDetail,
  SchoolTeacherListItem,
  SearchDiaryEntries200,
  SearchDiaryEntriesParams,
  SetRecordEnteredInput,
  SetSchoolGroupMembersInput,
  SetTeacherAssignmentInput,
  StripeCheckoutInput,
  StripeProductsResponse,
  StripeRedirectUrlResponse,
  StripeSubscriptionResponse,
  Student,
  StudentAnalytics,
  StudentImportInput,
  StudentImportResult,
  StudentInput,
  SubscriptionTierInfo,
  Task,
  TaskInput,
  TeacherAssignment,
  Timetable,
  TimetableDetail,
  TimetableInput,
  TimetableSlot,
  TimetableWeek,
  TimetableWeekInput,
  UndoSchoolMergeBody,
  UpdateCalendarEventInput,
  UpdateNoteBody,
  UpdateSchoolGroupInput,
  UploadUrlRequest,
  UploadUrlResponse,
  UpsertMarkbookMarkInput,
  UpsertSchoolCode200,
  UpsertSchoolCodeInput,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get teacher profile
 */
export const getGetProfileUrl = () => {
  return `/api/profile`;
};

export const getProfile = async (options?: RequestInit): Promise<Profile> => {
  return customFetch<Profile>(getGetProfileUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetProfileQueryKey = () => {
  return [`/api/profile`] as const;
};

export const getGetProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({
    signal,
  }) => getProfile({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProfile>>
>;
export type GetProfileQueryError = ErrorType<void>;

/**
 * @summary Get teacher profile
 */

export function useGetProfile<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProfileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create or update teacher profile
 */
export const getUpdateProfileUrl = () => {
  return `/api/profile`;
};

export const updateProfile = async (
  profileInput: ProfileInput,
  options?: RequestInit,
): Promise<Profile> => {
  return customFetch<Profile>(getUpdateProfileUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(profileInput),
  });
};

export const getUpdateProfileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProfile>>,
    TError,
    { data: BodyType<ProfileInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProfile>>,
  TError,
  { data: BodyType<ProfileInput> },
  TContext
> => {
  const mutationKey = ["updateProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProfile>>,
    { data: BodyType<ProfileInput> }
  > = (props) => {
    const { data } = props ?? {};

    return updateProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProfile>>
>;
export type UpdateProfileMutationBody = BodyType<ProfileInput>;
export type UpdateProfileMutationError = ErrorType<unknown>;

/**
 * @summary Create or update teacher profile
 */
export const useUpdateProfile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProfile>>,
    TError,
    { data: BodyType<ProfileInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProfile>>,
  TError,
  { data: BodyType<ProfileInput> },
  TContext
> => {
  return useMutation(getUpdateProfileMutationOptions(options));
};

/**
 * @summary List all timetables for the user
 */
export const getListTimetablesUrl = () => {
  return `/api/timetables`;
};

export const listTimetables = async (
  options?: RequestInit,
): Promise<Timetable[]> => {
  return customFetch<Timetable[]>(getListTimetablesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListTimetablesQueryKey = () => {
  return [`/api/timetables`] as const;
};

export const getListTimetablesQueryOptions = <
  TData = Awaited<ReturnType<typeof listTimetables>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listTimetables>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTimetablesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTimetables>>> = ({
    signal,
  }) => listTimetables({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTimetables>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTimetablesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTimetables>>
>;
export type ListTimetablesQueryError = ErrorType<unknown>;

/**
 * @summary List all timetables for the user
 */

export function useListTimetables<
  TData = Awaited<ReturnType<typeof listTimetables>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listTimetables>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTimetablesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a timetable
 */
export const getCreateTimetableUrl = () => {
  return `/api/timetables`;
};

export const createTimetable = async (
  timetableInput: TimetableInput,
  options?: RequestInit,
): Promise<Timetable> => {
  return customFetch<Timetable>(getCreateTimetableUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(timetableInput),
  });
};

export const getCreateTimetableMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTimetable>>,
    TError,
    { data: BodyType<TimetableInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTimetable>>,
  TError,
  { data: BodyType<TimetableInput> },
  TContext
> => {
  const mutationKey = ["createTimetable"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTimetable>>,
    { data: BodyType<TimetableInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createTimetable(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTimetableMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTimetable>>
>;
export type CreateTimetableMutationBody = BodyType<TimetableInput>;
export type CreateTimetableMutationError = ErrorType<unknown>;

/**
 * @summary Create a timetable
 */
export const useCreateTimetable = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTimetable>>,
    TError,
    { data: BodyType<TimetableInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTimetable>>,
  TError,
  { data: BodyType<TimetableInput> },
  TContext
> => {
  return useMutation(getCreateTimetableMutationOptions(options));
};

/**
 * @summary Get a timetable with weeks and slots
 */
export const getGetTimetableUrl = (timetableId: number) => {
  return `/api/timetables/${timetableId}`;
};

export const getTimetable = async (
  timetableId: number,
  options?: RequestInit,
): Promise<TimetableDetail> => {
  return customFetch<TimetableDetail>(getGetTimetableUrl(timetableId), {
    ...options,
    method: "GET",
  });
};

export const getGetTimetableQueryKey = (timetableId: number) => {
  return [`/api/timetables/${timetableId}`] as const;
};

export const getGetTimetableQueryOptions = <
  TData = Awaited<ReturnType<typeof getTimetable>>,
  TError = ErrorType<unknown>,
>(
  timetableId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTimetable>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTimetableQueryKey(timetableId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimetable>>> = ({
    signal,
  }) => getTimetable(timetableId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!timetableId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTimetable>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTimetableQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTimetable>>
>;
export type GetTimetableQueryError = ErrorType<unknown>;

/**
 * @summary Get a timetable with weeks and slots
 */

export function useGetTimetable<
  TData = Awaited<ReturnType<typeof getTimetable>>,
  TError = ErrorType<unknown>,
>(
  timetableId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTimetable>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTimetableQueryOptions(timetableId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a timetable
 */
export const getUpdateTimetableUrl = (timetableId: number) => {
  return `/api/timetables/${timetableId}`;
};

export const updateTimetable = async (
  timetableId: number,
  timetableInput: TimetableInput,
  options?: RequestInit,
): Promise<Timetable> => {
  return customFetch<Timetable>(getUpdateTimetableUrl(timetableId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(timetableInput),
  });
};

export const getUpdateTimetableMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTimetable>>,
    TError,
    { timetableId: number; data: BodyType<TimetableInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTimetable>>,
  TError,
  { timetableId: number; data: BodyType<TimetableInput> },
  TContext
> => {
  const mutationKey = ["updateTimetable"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTimetable>>,
    { timetableId: number; data: BodyType<TimetableInput> }
  > = (props) => {
    const { timetableId, data } = props ?? {};

    return updateTimetable(timetableId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTimetableMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTimetable>>
>;
export type UpdateTimetableMutationBody = BodyType<TimetableInput>;
export type UpdateTimetableMutationError = ErrorType<unknown>;

/**
 * @summary Update a timetable
 */
export const useUpdateTimetable = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTimetable>>,
    TError,
    { timetableId: number; data: BodyType<TimetableInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTimetable>>,
  TError,
  { timetableId: number; data: BodyType<TimetableInput> },
  TContext
> => {
  return useMutation(getUpdateTimetableMutationOptions(options));
};

/**
 * @summary Delete a timetable
 */
export const getDeleteTimetableUrl = (timetableId: number) => {
  return `/api/timetables/${timetableId}`;
};

export const deleteTimetable = async (
  timetableId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteTimetableUrl(timetableId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTimetableMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTimetable>>,
    TError,
    { timetableId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTimetable>>,
  TError,
  { timetableId: number },
  TContext
> => {
  const mutationKey = ["deleteTimetable"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTimetable>>,
    { timetableId: number }
  > = (props) => {
    const { timetableId } = props ?? {};

    return deleteTimetable(timetableId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTimetableMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTimetable>>
>;

export type DeleteTimetableMutationError = ErrorType<unknown>;

/**
 * @summary Delete a timetable
 */
export const useDeleteTimetable = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTimetable>>,
    TError,
    { timetableId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTimetable>>,
  TError,
  { timetableId: number },
  TContext
> => {
  return useMutation(getDeleteTimetableMutationOptions(options));
};

/**
 * @summary Add a week (A/B) to a timetable
 */
export const getCreateTimetableWeekUrl = (timetableId: number) => {
  return `/api/timetables/${timetableId}/weeks`;
};

export const createTimetableWeek = async (
  timetableId: number,
  timetableWeekInput: TimetableWeekInput,
  options?: RequestInit,
): Promise<TimetableWeek> => {
  return customFetch<TimetableWeek>(getCreateTimetableWeekUrl(timetableId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(timetableWeekInput),
  });
};

export const getCreateTimetableWeekMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTimetableWeek>>,
    TError,
    { timetableId: number; data: BodyType<TimetableWeekInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTimetableWeek>>,
  TError,
  { timetableId: number; data: BodyType<TimetableWeekInput> },
  TContext
> => {
  const mutationKey = ["createTimetableWeek"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTimetableWeek>>,
    { timetableId: number; data: BodyType<TimetableWeekInput> }
  > = (props) => {
    const { timetableId, data } = props ?? {};

    return createTimetableWeek(timetableId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTimetableWeekMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTimetableWeek>>
>;
export type CreateTimetableWeekMutationBody = BodyType<TimetableWeekInput>;
export type CreateTimetableWeekMutationError = ErrorType<unknown>;

/**
 * @summary Add a week (A/B) to a timetable
 */
export const useCreateTimetableWeek = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTimetableWeek>>,
    TError,
    { timetableId: number; data: BodyType<TimetableWeekInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTimetableWeek>>,
  TError,
  { timetableId: number; data: BodyType<TimetableWeekInput> },
  TContext
> => {
  return useMutation(getCreateTimetableWeekMutationOptions(options));
};

/**
 * @summary Save all slots for a week
 */
export const getSaveTimetableSlotsUrl = (
  timetableId: number,
  weekId: number,
) => {
  return `/api/timetables/${timetableId}/weeks/${weekId}/slots`;
};

export const saveTimetableSlots = async (
  timetableId: number,
  weekId: number,
  saveTimetableSlotsBody: SaveTimetableSlotsBody,
  options?: RequestInit,
): Promise<TimetableSlot[]> => {
  return customFetch<TimetableSlot[]>(
    getSaveTimetableSlotsUrl(timetableId, weekId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(saveTimetableSlotsBody),
    },
  );
};

export const getSaveTimetableSlotsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveTimetableSlots>>,
    TError,
    {
      timetableId: number;
      weekId: number;
      data: BodyType<SaveTimetableSlotsBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveTimetableSlots>>,
  TError,
  {
    timetableId: number;
    weekId: number;
    data: BodyType<SaveTimetableSlotsBody>;
  },
  TContext
> => {
  const mutationKey = ["saveTimetableSlots"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveTimetableSlots>>,
    {
      timetableId: number;
      weekId: number;
      data: BodyType<SaveTimetableSlotsBody>;
    }
  > = (props) => {
    const { timetableId, weekId, data } = props ?? {};

    return saveTimetableSlots(timetableId, weekId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveTimetableSlotsMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveTimetableSlots>>
>;
export type SaveTimetableSlotsMutationBody = BodyType<SaveTimetableSlotsBody>;
export type SaveTimetableSlotsMutationError = ErrorType<unknown>;

/**
 * @summary Save all slots for a week
 */
export const useSaveTimetableSlots = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveTimetableSlots>>,
    TError,
    {
      timetableId: number;
      weekId: number;
      data: BodyType<SaveTimetableSlotsBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveTimetableSlots>>,
  TError,
  {
    timetableId: number;
    weekId: number;
    data: BodyType<SaveTimetableSlotsBody>;
  },
  TContext
> => {
  return useMutation(getSaveTimetableSlotsMutationOptions(options));
};

/**
 * @summary Replace target timetable's weeks/slots with copies from source
 */
export const getCopyTimetableFromUrl = (
  timetableId: number,
  sourceTimetableId: number,
) => {
  return `/api/timetables/${timetableId}/copy-from/${sourceTimetableId}`;
};

export const copyTimetableFrom = async (
  timetableId: number,
  sourceTimetableId: number,
  options?: RequestInit,
): Promise<CopyTimetableResult> => {
  return customFetch<CopyTimetableResult>(
    getCopyTimetableFromUrl(timetableId, sourceTimetableId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getCopyTimetableFromMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof copyTimetableFrom>>,
    TError,
    { timetableId: number; sourceTimetableId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof copyTimetableFrom>>,
  TError,
  { timetableId: number; sourceTimetableId: number },
  TContext
> => {
  const mutationKey = ["copyTimetableFrom"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof copyTimetableFrom>>,
    { timetableId: number; sourceTimetableId: number }
  > = (props) => {
    const { timetableId, sourceTimetableId } = props ?? {};

    return copyTimetableFrom(timetableId, sourceTimetableId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CopyTimetableFromMutationResult = NonNullable<
  Awaited<ReturnType<typeof copyTimetableFrom>>
>;

export type CopyTimetableFromMutationError = ErrorType<unknown>;

/**
 * @summary Replace target timetable's weeks/slots with copies from source
 */
export const useCopyTimetableFrom = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof copyTimetableFrom>>,
    TError,
    { timetableId: number; sourceTimetableId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof copyTimetableFrom>>,
  TError,
  { timetableId: number; sourceTimetableId: number },
  TContext
> => {
  return useMutation(getCopyTimetableFromMutationOptions(options));
};

/**
 * @summary Archive or unarchive a timetable
 */
export const getArchiveTimetableUrl = (timetableId: number) => {
  return `/api/timetables/${timetableId}/archive`;
};

export const archiveTimetable = async (
  timetableId: number,
  archiveTimetableInput: ArchiveTimetableInput,
  options?: RequestInit,
): Promise<Timetable> => {
  return customFetch<Timetable>(getArchiveTimetableUrl(timetableId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(archiveTimetableInput),
  });
};

export const getArchiveTimetableMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveTimetable>>,
    TError,
    { timetableId: number; data: BodyType<ArchiveTimetableInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveTimetable>>,
  TError,
  { timetableId: number; data: BodyType<ArchiveTimetableInput> },
  TContext
> => {
  const mutationKey = ["archiveTimetable"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveTimetable>>,
    { timetableId: number; data: BodyType<ArchiveTimetableInput> }
  > = (props) => {
    const { timetableId, data } = props ?? {};

    return archiveTimetable(timetableId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveTimetableMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveTimetable>>
>;
export type ArchiveTimetableMutationBody = BodyType<ArchiveTimetableInput>;
export type ArchiveTimetableMutationError = ErrorType<unknown>;

/**
 * @summary Archive or unarchive a timetable
 */
export const useArchiveTimetable = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveTimetable>>,
    TError,
    { timetableId: number; data: BodyType<ArchiveTimetableInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof archiveTimetable>>,
  TError,
  { timetableId: number; data: BodyType<ArchiveTimetableInput> },
  TContext
> => {
  return useMutation(getArchiveTimetableMutationOptions(options));
};

/**
 * @summary List all courses
 */
export const getListCoursesUrl = (params?: ListCoursesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/courses?${stringifiedParams}`
    : `/api/courses`;
};

export const listCourses = async (
  params?: ListCoursesParams,
  options?: RequestInit,
): Promise<Course[]> => {
  return customFetch<Course[]>(getListCoursesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListCoursesQueryKey = (params?: ListCoursesParams) => {
  return [`/api/courses`, ...(params ? [params] : [])] as const;
};

export const getListCoursesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCourses>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCoursesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCourses>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCoursesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCourses>>> = ({
    signal,
  }) => listCourses(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCourses>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCoursesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCourses>>
>;
export type ListCoursesQueryError = ErrorType<unknown>;

/**
 * @summary List all courses
 */

export function useListCourses<
  TData = Awaited<ReturnType<typeof listCourses>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCoursesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCourses>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCoursesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a course
 */
export const getCreateCourseUrl = () => {
  return `/api/courses`;
};

export const createCourse = async (
  courseInput: CourseInput,
  options?: RequestInit,
): Promise<Course> => {
  return customFetch<Course>(getCreateCourseUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(courseInput),
  });
};

export const getCreateCourseMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCourse>>,
    TError,
    { data: BodyType<CourseInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCourse>>,
  TError,
  { data: BodyType<CourseInput> },
  TContext
> => {
  const mutationKey = ["createCourse"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCourse>>,
    { data: BodyType<CourseInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createCourse(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCourseMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCourse>>
>;
export type CreateCourseMutationBody = BodyType<CourseInput>;
export type CreateCourseMutationError = ErrorType<unknown>;

/**
 * @summary Create a course
 */
export const useCreateCourse = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCourse>>,
    TError,
    { data: BodyType<CourseInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCourse>>,
  TError,
  { data: BodyType<CourseInput> },
  TContext
> => {
  return useMutation(getCreateCourseMutationOptions(options));
};

/**
 * @summary Update a course
 */
export const getUpdateCourseUrl = (courseId: number) => {
  return `/api/courses/${courseId}`;
};

export const updateCourse = async (
  courseId: number,
  courseInput: CourseInput,
  options?: RequestInit,
): Promise<Course> => {
  return customFetch<Course>(getUpdateCourseUrl(courseId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(courseInput),
  });
};

export const getUpdateCourseMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCourse>>,
    TError,
    { courseId: number; data: BodyType<CourseInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCourse>>,
  TError,
  { courseId: number; data: BodyType<CourseInput> },
  TContext
> => {
  const mutationKey = ["updateCourse"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCourse>>,
    { courseId: number; data: BodyType<CourseInput> }
  > = (props) => {
    const { courseId, data } = props ?? {};

    return updateCourse(courseId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCourseMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCourse>>
>;
export type UpdateCourseMutationBody = BodyType<CourseInput>;
export type UpdateCourseMutationError = ErrorType<unknown>;

/**
 * @summary Update a course
 */
export const useUpdateCourse = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCourse>>,
    TError,
    { courseId: number; data: BodyType<CourseInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCourse>>,
  TError,
  { courseId: number; data: BodyType<CourseInput> },
  TContext
> => {
  return useMutation(getUpdateCourseMutationOptions(options));
};

/**
 * @summary Delete a course
 */
export const getDeleteCourseUrl = (courseId: number) => {
  return `/api/courses/${courseId}`;
};

export const deleteCourse = async (
  courseId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteCourseUrl(courseId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCourseMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCourse>>,
    TError,
    { courseId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCourse>>,
  TError,
  { courseId: number },
  TContext
> => {
  const mutationKey = ["deleteCourse"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCourse>>,
    { courseId: number }
  > = (props) => {
    const { courseId } = props ?? {};

    return deleteCourse(courseId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCourseMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCourse>>
>;

export type DeleteCourseMutationError = ErrorType<unknown>;

/**
 * @summary Delete a course
 */
export const useDeleteCourse = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCourse>>,
    TError,
    { courseId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCourse>>,
  TError,
  { courseId: number },
  TContext
> => {
  return useMutation(getDeleteCourseMutationOptions(options));
};

/**
 * @summary List all students
 */
export const getListStudentsUrl = (params?: ListStudentsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/students?${stringifiedParams}`
    : `/api/students`;
};

export const listStudents = async (
  params?: ListStudentsParams,
  options?: RequestInit,
): Promise<Student[]> => {
  return customFetch<Student[]>(getListStudentsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListStudentsQueryKey = (params?: ListStudentsParams) => {
  return [`/api/students`, ...(params ? [params] : [])] as const;
};

export const getListStudentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listStudents>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStudentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listStudents>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListStudentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listStudents>>> = ({
    signal,
  }) => listStudents(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listStudents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStudentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStudents>>
>;
export type ListStudentsQueryError = ErrorType<unknown>;

/**
 * @summary List all students
 */

export function useListStudents<
  TData = Awaited<ReturnType<typeof listStudents>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStudentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listStudents>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListStudentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a student
 */
export const getCreateStudentUrl = () => {
  return `/api/students`;
};

export const createStudent = async (
  studentInput: StudentInput,
  options?: RequestInit,
): Promise<Student> => {
  return customFetch<Student>(getCreateStudentUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(studentInput),
  });
};

export const getCreateStudentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStudent>>,
    TError,
    { data: BodyType<StudentInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStudent>>,
  TError,
  { data: BodyType<StudentInput> },
  TContext
> => {
  const mutationKey = ["createStudent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStudent>>,
    { data: BodyType<StudentInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createStudent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStudentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStudent>>
>;
export type CreateStudentMutationBody = BodyType<StudentInput>;
export type CreateStudentMutationError = ErrorType<unknown>;

/**
 * @summary Create a student
 */
export const useCreateStudent = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStudent>>,
    TError,
    { data: BodyType<StudentInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createStudent>>,
  TError,
  { data: BodyType<StudentInput> },
  TContext
> => {
  return useMutation(getCreateStudentMutationOptions(options));
};

/**
 * @summary Update a student
 */
export const getUpdateStudentUrl = (studentId: number) => {
  return `/api/students/${studentId}`;
};

export const updateStudent = async (
  studentId: number,
  studentInput: StudentInput,
  options?: RequestInit,
): Promise<Student> => {
  return customFetch<Student>(getUpdateStudentUrl(studentId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(studentInput),
  });
};

export const getUpdateStudentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStudent>>,
    TError,
    { studentId: number; data: BodyType<StudentInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStudent>>,
  TError,
  { studentId: number; data: BodyType<StudentInput> },
  TContext
> => {
  const mutationKey = ["updateStudent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStudent>>,
    { studentId: number; data: BodyType<StudentInput> }
  > = (props) => {
    const { studentId, data } = props ?? {};

    return updateStudent(studentId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStudentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStudent>>
>;
export type UpdateStudentMutationBody = BodyType<StudentInput>;
export type UpdateStudentMutationError = ErrorType<unknown>;

/**
 * @summary Update a student
 */
export const useUpdateStudent = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStudent>>,
    TError,
    { studentId: number; data: BodyType<StudentInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateStudent>>,
  TError,
  { studentId: number; data: BodyType<StudentInput> },
  TContext
> => {
  return useMutation(getUpdateStudentMutationOptions(options));
};

/**
 * @summary Delete a student
 */
export const getDeleteStudentUrl = (studentId: number) => {
  return `/api/students/${studentId}`;
};

export const deleteStudent = async (
  studentId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteStudentUrl(studentId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteStudentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStudent>>,
    TError,
    { studentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteStudent>>,
  TError,
  { studentId: number },
  TContext
> => {
  const mutationKey = ["deleteStudent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteStudent>>,
    { studentId: number }
  > = (props) => {
    const { studentId } = props ?? {};

    return deleteStudent(studentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteStudentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteStudent>>
>;

export type DeleteStudentMutationError = ErrorType<unknown>;

/**
 * @summary Delete a student
 */
export const useDeleteStudent = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStudent>>,
    TError,
    { studentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteStudent>>,
  TError,
  { studentId: number },
  TContext
> => {
  return useMutation(getDeleteStudentMutationOptions(options));
};

/**
 * @summary Archive or unarchive a student. School-owned students require the head teacher; private students require ownership.
 */
export const getArchiveStudentUrl = (studentId: number) => {
  return `/api/students/${studentId}/archive`;
};

export const archiveStudent = async (
  studentId: number,
  archiveBody: ArchiveBody,
  options?: RequestInit,
): Promise<Student> => {
  return customFetch<Student>(getArchiveStudentUrl(studentId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(archiveBody),
  });
};

export const getArchiveStudentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveStudent>>,
    TError,
    { studentId: number; data: BodyType<ArchiveBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveStudent>>,
  TError,
  { studentId: number; data: BodyType<ArchiveBody> },
  TContext
> => {
  const mutationKey = ["archiveStudent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveStudent>>,
    { studentId: number; data: BodyType<ArchiveBody> }
  > = (props) => {
    const { studentId, data } = props ?? {};

    return archiveStudent(studentId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveStudentMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveStudent>>
>;
export type ArchiveStudentMutationBody = BodyType<ArchiveBody>;
export type ArchiveStudentMutationError = ErrorType<unknown>;

/**
 * @summary Archive or unarchive a student. School-owned students require the head teacher; private students require ownership.
 */
export const useArchiveStudent = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveStudent>>,
    TError,
    { studentId: number; data: BodyType<ArchiveBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof archiveStudent>>,
  TError,
  { studentId: number; data: BodyType<ArchiveBody> },
  TContext
> => {
  return useMutation(getArchiveStudentMutationOptions(options));
};

/**
 * Idempotent fresh-start helper for teachers who join a school mid-year.
In one transaction:
  - Archives the user's most recent active private timetable and ends
    it the day before joinDate (skipped if startDate >= joinDate).
  - Marks every non-archived private (school_id IS NULL) class and
    course as hidden via class_user_prefs / course_user_prefs.
  - Creates a new empty timetable starting on joinDate (12-month
    default range) with one default week labelled "A".
Re-running with the same joinDate reuses the existing new timetable
instead of creating a duplicate.

 * @summary Wind down a teacher's pre-school timetable + private classes/courses and create a new timetable starting from the chosen join date.
 */
export const getSchoolFreshStartUrl = () => {
  return `/api/school/fresh-start`;
};

export const schoolFreshStart = async (
  schoolFreshStartInput: SchoolFreshStartInput,
  options?: RequestInit,
): Promise<SchoolFreshStartResult> => {
  return customFetch<SchoolFreshStartResult>(getSchoolFreshStartUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(schoolFreshStartInput),
  });
};

export const getSchoolFreshStartMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof schoolFreshStart>>,
    TError,
    { data: BodyType<SchoolFreshStartInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof schoolFreshStart>>,
  TError,
  { data: BodyType<SchoolFreshStartInput> },
  TContext
> => {
  const mutationKey = ["schoolFreshStart"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof schoolFreshStart>>,
    { data: BodyType<SchoolFreshStartInput> }
  > = (props) => {
    const { data } = props ?? {};

    return schoolFreshStart(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SchoolFreshStartMutationResult = NonNullable<
  Awaited<ReturnType<typeof schoolFreshStart>>
>;
export type SchoolFreshStartMutationBody = BodyType<SchoolFreshStartInput>;
export type SchoolFreshStartMutationError = ErrorType<unknown>;

/**
 * @summary Wind down a teacher's pre-school timetable + private classes/courses and create a new timetable starting from the chosen join date.
 */
export const useSchoolFreshStart = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof schoolFreshStart>>,
    TError,
    { data: BodyType<SchoolFreshStartInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof schoolFreshStart>>,
  TError,
  { data: BodyType<SchoolFreshStartInput> },
  TContext
> => {
  return useMutation(getSchoolFreshStartMutationOptions(options));
};

/**
 * @summary Bulk-create school-owned classes and courses (head teacher only). Idempotent — re-running with the same names is safe.
 */
export const getImportSchoolClassesCoursesUrl = () => {
  return `/api/school/import-classes-courses`;
};

export const importSchoolClassesCourses = async (
  schoolStructureImportInput: SchoolStructureImportInput,
  options?: RequestInit,
): Promise<SchoolStructureImportResult> => {
  return customFetch<SchoolStructureImportResult>(
    getImportSchoolClassesCoursesUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(schoolStructureImportInput),
    },
  );
};

export const getImportSchoolClassesCoursesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importSchoolClassesCourses>>,
    TError,
    { data: BodyType<SchoolStructureImportInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importSchoolClassesCourses>>,
  TError,
  { data: BodyType<SchoolStructureImportInput> },
  TContext
> => {
  const mutationKey = ["importSchoolClassesCourses"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importSchoolClassesCourses>>,
    { data: BodyType<SchoolStructureImportInput> }
  > = (props) => {
    const { data } = props ?? {};

    return importSchoolClassesCourses(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportSchoolClassesCoursesMutationResult = NonNullable<
  Awaited<ReturnType<typeof importSchoolClassesCourses>>
>;
export type ImportSchoolClassesCoursesMutationBody =
  BodyType<SchoolStructureImportInput>;
export type ImportSchoolClassesCoursesMutationError = ErrorType<unknown>;

/**
 * @summary Bulk-create school-owned classes and courses (head teacher only). Idempotent — re-running with the same names is safe.
 */
export const useImportSchoolClassesCourses = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importSchoolClassesCourses>>,
    TError,
    { data: BodyType<SchoolStructureImportInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof importSchoolClassesCourses>>,
  TError,
  { data: BodyType<SchoolStructureImportInput> },
  TContext
> => {
  return useMutation(getImportSchoolClassesCoursesMutationOptions(options));
};

/**
 * @summary Bulk-create students, optionally assigning to classes by name
 */
export const getImportStudentsUrl = () => {
  return `/api/students/import`;
};

export const importStudents = async (
  studentImportInput: StudentImportInput,
  options?: RequestInit,
): Promise<StudentImportResult> => {
  return customFetch<StudentImportResult>(getImportStudentsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(studentImportInput),
  });
};

export const getImportStudentsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importStudents>>,
    TError,
    { data: BodyType<StudentImportInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importStudents>>,
  TError,
  { data: BodyType<StudentImportInput> },
  TContext
> => {
  const mutationKey = ["importStudents"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importStudents>>,
    { data: BodyType<StudentImportInput> }
  > = (props) => {
    const { data } = props ?? {};

    return importStudents(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportStudentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof importStudents>>
>;
export type ImportStudentsMutationBody = BodyType<StudentImportInput>;
export type ImportStudentsMutationError = ErrorType<unknown>;

/**
 * @summary Bulk-create students, optionally assigning to classes by name
 */
export const useImportStudents = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importStudents>>,
    TError,
    { data: BodyType<StudentImportInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof importStudents>>,
  TError,
  { data: BodyType<StudentImportInput> },
  TContext
> => {
  return useMutation(getImportStudentsMutationOptions(options));
};

/**
 * @summary Download all students as CSV
 */
export const getExportStudentsCsvUrl = () => {
  return `/api/students/export`;
};

export const exportStudentsCsv = async (
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getExportStudentsCsvUrl(), {
    ...options,
    method: "GET",
  });
};

export const getExportStudentsCsvQueryKey = () => {
  return [`/api/students/export`] as const;
};

export const getExportStudentsCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof exportStudentsCsv>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof exportStudentsCsv>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportStudentsCsvQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportStudentsCsv>>
  > = ({ signal }) => exportStudentsCsv({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportStudentsCsv>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportStudentsCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportStudentsCsv>>
>;
export type ExportStudentsCsvQueryError = ErrorType<unknown>;

/**
 * @summary Download all students as CSV
 */

export function useExportStudentsCsv<
  TData = Awaited<ReturnType<typeof exportStudentsCsv>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof exportStudentsCsv>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExportStudentsCsvQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all classes
 */
export const getListClassesUrl = (params?: ListClassesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/classes?${stringifiedParams}`
    : `/api/classes`;
};

export const listClasses = async (
  params?: ListClassesParams,
  options?: RequestInit,
): Promise<Class[]> => {
  return customFetch<Class[]>(getListClassesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListClassesQueryKey = (params?: ListClassesParams) => {
  return [`/api/classes`, ...(params ? [params] : [])] as const;
};

export const getListClassesQueryOptions = <
  TData = Awaited<ReturnType<typeof listClasses>>,
  TError = ErrorType<unknown>,
>(
  params?: ListClassesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listClasses>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListClassesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listClasses>>> = ({
    signal,
  }) => listClasses(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listClasses>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListClassesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClasses>>
>;
export type ListClassesQueryError = ErrorType<unknown>;

/**
 * @summary List all classes
 */

export function useListClasses<
  TData = Awaited<ReturnType<typeof listClasses>>,
  TError = ErrorType<unknown>,
>(
  params?: ListClassesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listClasses>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListClassesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a class
 */
export const getCreateClassUrl = () => {
  return `/api/classes`;
};

export const createClass = async (
  classInput: ClassInput,
  options?: RequestInit,
): Promise<Class> => {
  return customFetch<Class>(getCreateClassUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(classInput),
  });
};

export const getCreateClassMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClass>>,
    TError,
    { data: BodyType<ClassInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createClass>>,
  TError,
  { data: BodyType<ClassInput> },
  TContext
> => {
  const mutationKey = ["createClass"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createClass>>,
    { data: BodyType<ClassInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createClass(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClass>>
>;
export type CreateClassMutationBody = BodyType<ClassInput>;
export type CreateClassMutationError = ErrorType<unknown>;

/**
 * @summary Create a class
 */
export const useCreateClass = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClass>>,
    TError,
    { data: BodyType<ClassInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createClass>>,
  TError,
  { data: BodyType<ClassInput> },
  TContext
> => {
  return useMutation(getCreateClassMutationOptions(options));
};

/**
 * @summary Update a class
 */
export const getUpdateClassUrl = (classId: number) => {
  return `/api/classes/${classId}`;
};

export const updateClass = async (
  classId: number,
  classInput: ClassInput,
  options?: RequestInit,
): Promise<Class> => {
  return customFetch<Class>(getUpdateClassUrl(classId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(classInput),
  });
};

export const getUpdateClassMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClass>>,
    TError,
    { classId: number; data: BodyType<ClassInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateClass>>,
  TError,
  { classId: number; data: BodyType<ClassInput> },
  TContext
> => {
  const mutationKey = ["updateClass"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClass>>,
    { classId: number; data: BodyType<ClassInput> }
  > = (props) => {
    const { classId, data } = props ?? {};

    return updateClass(classId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClass>>
>;
export type UpdateClassMutationBody = BodyType<ClassInput>;
export type UpdateClassMutationError = ErrorType<unknown>;

/**
 * @summary Update a class
 */
export const useUpdateClass = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClass>>,
    TError,
    { classId: number; data: BodyType<ClassInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateClass>>,
  TError,
  { classId: number; data: BodyType<ClassInput> },
  TContext
> => {
  return useMutation(getUpdateClassMutationOptions(options));
};

/**
 * @summary Delete a class
 */
export const getDeleteClassUrl = (classId: number) => {
  return `/api/classes/${classId}`;
};

export const deleteClass = async (
  classId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteClassUrl(classId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteClassMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClass>>,
    TError,
    { classId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteClass>>,
  TError,
  { classId: number },
  TContext
> => {
  const mutationKey = ["deleteClass"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteClass>>,
    { classId: number }
  > = (props) => {
    const { classId } = props ?? {};

    return deleteClass(classId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteClass>>
>;

export type DeleteClassMutationError = ErrorType<unknown>;

/**
 * @summary Delete a class
 */
export const useDeleteClass = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClass>>,
    TError,
    { classId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteClass>>,
  TError,
  { classId: number },
  TContext
> => {
  return useMutation(getDeleteClassMutationOptions(options));
};

/**
 * @summary Pre-flight count of rows that a hard-delete of this class would affect. Used by the client to render the "this will permanently delete N students linked, M timetable periods…" warning before the destructive action runs. Counts are scoped to the calling user's RLS visibility.
 */
export const getGetClassDependentsCountUrl = (classId: number) => {
  return `/api/classes/${classId}/dependents`;
};

export const getClassDependentsCount = async (
  classId: number,
  options?: RequestInit,
): Promise<ClassDependentsCount> => {
  return customFetch<ClassDependentsCount>(
    getGetClassDependentsCountUrl(classId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetClassDependentsCountQueryKey = (classId: number) => {
  return [`/api/classes/${classId}/dependents`] as const;
};

export const getGetClassDependentsCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassDependentsCount>>,
  TError = ErrorType<unknown>,
>(
  classId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassDependentsCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClassDependentsCountQueryKey(classId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassDependentsCount>>
  > = ({ signal }) =>
    getClassDependentsCount(classId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!classId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassDependentsCount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetClassDependentsCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassDependentsCount>>
>;
export type GetClassDependentsCountQueryError = ErrorType<unknown>;

/**
 * @summary Pre-flight count of rows that a hard-delete of this class would affect. Used by the client to render the "this will permanently delete N students linked, M timetable periods…" warning before the destructive action runs. Counts are scoped to the calling user's RLS visibility.
 */

export function useGetClassDependentsCount<
  TData = Awaited<ReturnType<typeof getClassDependentsCount>>,
  TError = ErrorType<unknown>,
>(
  classId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassDependentsCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetClassDependentsCountQueryOptions(classId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Archive or unarchive a class (year-end). School-owned classes require the head teacher; private classes require ownership.
 */
export const getArchiveClassUrl = (classId: number) => {
  return `/api/classes/${classId}/archive`;
};

export const archiveClass = async (
  classId: number,
  archiveBody: ArchiveBody,
  options?: RequestInit,
): Promise<Class> => {
  return customFetch<Class>(getArchiveClassUrl(classId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(archiveBody),
  });
};

export const getArchiveClassMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveClass>>,
    TError,
    { classId: number; data: BodyType<ArchiveBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveClass>>,
  TError,
  { classId: number; data: BodyType<ArchiveBody> },
  TContext
> => {
  const mutationKey = ["archiveClass"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveClass>>,
    { classId: number; data: BodyType<ArchiveBody> }
  > = (props) => {
    const { classId, data } = props ?? {};

    return archiveClass(classId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveClass>>
>;
export type ArchiveClassMutationBody = BodyType<ArchiveBody>;
export type ArchiveClassMutationError = ErrorType<unknown>;

/**
 * @summary Archive or unarchive a class (year-end). School-owned classes require the head teacher; private classes require ownership.
 */
export const useArchiveClass = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveClass>>,
    TError,
    { classId: number; data: BodyType<ArchiveBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof archiveClass>>,
  TError,
  { classId: number; data: BodyType<ArchiveBody> },
  TContext
> => {
  return useMutation(getArchiveClassMutationOptions(options));
};

/**
 * @summary Upsert per-teacher prefs for a class (hide/unhide). Per-user; never affects other teachers.
 */
export const getUpdateClassPrefsUrl = (classId: number) => {
  return `/api/classes/${classId}/prefs`;
};

export const updateClassPrefs = async (
  classId: number,
  classPrefsInput: ClassPrefsInput,
  options?: RequestInit,
): Promise<Class> => {
  return customFetch<Class>(getUpdateClassPrefsUrl(classId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(classPrefsInput),
  });
};

export const getUpdateClassPrefsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClassPrefs>>,
    TError,
    { classId: number; data: BodyType<ClassPrefsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateClassPrefs>>,
  TError,
  { classId: number; data: BodyType<ClassPrefsInput> },
  TContext
> => {
  const mutationKey = ["updateClassPrefs"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClassPrefs>>,
    { classId: number; data: BodyType<ClassPrefsInput> }
  > = (props) => {
    const { classId, data } = props ?? {};

    return updateClassPrefs(classId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateClassPrefsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClassPrefs>>
>;
export type UpdateClassPrefsMutationBody = BodyType<ClassPrefsInput>;
export type UpdateClassPrefsMutationError = ErrorType<unknown>;

/**
 * @summary Upsert per-teacher prefs for a class (hide/unhide). Per-user; never affects other teachers.
 */
export const useUpdateClassPrefs = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClassPrefs>>,
    TError,
    { classId: number; data: BodyType<ClassPrefsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateClassPrefs>>,
  TError,
  { classId: number; data: BodyType<ClassPrefsInput> },
  TContext
> => {
  return useMutation(getUpdateClassPrefsMutationOptions(options));
};

/**
 * @summary Set per-teacher sort order for the supplied class IDs. Each ID's sortOrder = its index.
 */
export const getReorderClassesUrl = () => {
  return `/api/classes/reorder`;
};

export const reorderClasses = async (
  reorderInput: ReorderInput,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getReorderClassesUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reorderInput),
  });
};

export const getReorderClassesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderClasses>>,
    TError,
    { data: BodyType<ReorderInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderClasses>>,
  TError,
  { data: BodyType<ReorderInput> },
  TContext
> => {
  const mutationKey = ["reorderClasses"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderClasses>>,
    { data: BodyType<ReorderInput> }
  > = (props) => {
    const { data } = props ?? {};

    return reorderClasses(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderClassesMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderClasses>>
>;
export type ReorderClassesMutationBody = BodyType<ReorderInput>;
export type ReorderClassesMutationError = ErrorType<unknown>;

/**
 * @summary Set per-teacher sort order for the supplied class IDs. Each ID's sortOrder = its index.
 */
export const useReorderClasses = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderClasses>>,
    TError,
    { data: BodyType<ReorderInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reorderClasses>>,
  TError,
  { data: BodyType<ReorderInput> },
  TContext
> => {
  return useMutation(getReorderClassesMutationOptions(options));
};

/**
 * @summary Pre-flight count of rows that a hard-delete of this course would affect. Used by the client to render the "this will permanently delete X classes, Y diary entries…" warning before the destructive action runs. Counts are scoped to the calling user's RLS visibility.
 */
export const getGetCourseDependentsCountUrl = (courseId: number) => {
  return `/api/courses/${courseId}/dependents`;
};

export const getCourseDependentsCount = async (
  courseId: number,
  options?: RequestInit,
): Promise<CourseDependentsCount> => {
  return customFetch<CourseDependentsCount>(
    getGetCourseDependentsCountUrl(courseId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetCourseDependentsCountQueryKey = (courseId: number) => {
  return [`/api/courses/${courseId}/dependents`] as const;
};

export const getGetCourseDependentsCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getCourseDependentsCount>>,
  TError = ErrorType<unknown>,
>(
  courseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCourseDependentsCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCourseDependentsCountQueryKey(courseId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCourseDependentsCount>>
  > = ({ signal }) =>
    getCourseDependentsCount(courseId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!courseId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCourseDependentsCount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCourseDependentsCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCourseDependentsCount>>
>;
export type GetCourseDependentsCountQueryError = ErrorType<unknown>;

/**
 * @summary Pre-flight count of rows that a hard-delete of this course would affect. Used by the client to render the "this will permanently delete X classes, Y diary entries…" warning before the destructive action runs. Counts are scoped to the calling user's RLS visibility.
 */

export function useGetCourseDependentsCount<
  TData = Awaited<ReturnType<typeof getCourseDependentsCount>>,
  TError = ErrorType<unknown>,
>(
  courseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCourseDependentsCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCourseDependentsCountQueryOptions(
    courseId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Archive or unarchive a course (year-end). School-owned courses require the head teacher; private courses require ownership.
 */
export const getArchiveCourseUrl = (courseId: number) => {
  return `/api/courses/${courseId}/archive`;
};

export const archiveCourse = async (
  courseId: number,
  archiveBody: ArchiveBody,
  options?: RequestInit,
): Promise<Course> => {
  return customFetch<Course>(getArchiveCourseUrl(courseId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(archiveBody),
  });
};

export const getArchiveCourseMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveCourse>>,
    TError,
    { courseId: number; data: BodyType<ArchiveBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveCourse>>,
  TError,
  { courseId: number; data: BodyType<ArchiveBody> },
  TContext
> => {
  const mutationKey = ["archiveCourse"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveCourse>>,
    { courseId: number; data: BodyType<ArchiveBody> }
  > = (props) => {
    const { courseId, data } = props ?? {};

    return archiveCourse(courseId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveCourseMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveCourse>>
>;
export type ArchiveCourseMutationBody = BodyType<ArchiveBody>;
export type ArchiveCourseMutationError = ErrorType<unknown>;

/**
 * @summary Archive or unarchive a course (year-end). School-owned courses require the head teacher; private courses require ownership.
 */
export const useArchiveCourse = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveCourse>>,
    TError,
    { courseId: number; data: BodyType<ArchiveBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof archiveCourse>>,
  TError,
  { courseId: number; data: BodyType<ArchiveBody> },
  TContext
> => {
  return useMutation(getArchiveCourseMutationOptions(options));
};

/**
 * @summary Upsert per-teacher prefs for a course (hide/unhide). Per-user; never affects other teachers.
 */
export const getUpdateCoursePrefsUrl = (courseId: number) => {
  return `/api/courses/${courseId}/prefs`;
};

export const updateCoursePrefs = async (
  courseId: number,
  coursePrefsInput: CoursePrefsInput,
  options?: RequestInit,
): Promise<Course> => {
  return customFetch<Course>(getUpdateCoursePrefsUrl(courseId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(coursePrefsInput),
  });
};

export const getUpdateCoursePrefsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCoursePrefs>>,
    TError,
    { courseId: number; data: BodyType<CoursePrefsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCoursePrefs>>,
  TError,
  { courseId: number; data: BodyType<CoursePrefsInput> },
  TContext
> => {
  const mutationKey = ["updateCoursePrefs"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCoursePrefs>>,
    { courseId: number; data: BodyType<CoursePrefsInput> }
  > = (props) => {
    const { courseId, data } = props ?? {};

    return updateCoursePrefs(courseId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCoursePrefsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCoursePrefs>>
>;
export type UpdateCoursePrefsMutationBody = BodyType<CoursePrefsInput>;
export type UpdateCoursePrefsMutationError = ErrorType<unknown>;

/**
 * @summary Upsert per-teacher prefs for a course (hide/unhide). Per-user; never affects other teachers.
 */
export const useUpdateCoursePrefs = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCoursePrefs>>,
    TError,
    { courseId: number; data: BodyType<CoursePrefsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCoursePrefs>>,
  TError,
  { courseId: number; data: BodyType<CoursePrefsInput> },
  TContext
> => {
  return useMutation(getUpdateCoursePrefsMutationOptions(options));
};

/**
 * @summary Set per-teacher sort order for the supplied course IDs. Each ID's sortOrder = its index.
 */
export const getReorderCoursesUrl = () => {
  return `/api/courses/reorder`;
};

export const reorderCourses = async (
  reorderInput: ReorderInput,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getReorderCoursesUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reorderInput),
  });
};

export const getReorderCoursesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderCourses>>,
    TError,
    { data: BodyType<ReorderInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderCourses>>,
  TError,
  { data: BodyType<ReorderInput> },
  TContext
> => {
  const mutationKey = ["reorderCourses"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderCourses>>,
    { data: BodyType<ReorderInput> }
  > = (props) => {
    const { data } = props ?? {};

    return reorderCourses(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderCoursesMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderCourses>>
>;
export type ReorderCoursesMutationBody = BodyType<ReorderInput>;
export type ReorderCoursesMutationError = ErrorType<unknown>;

/**
 * @summary Set per-teacher sort order for the supplied course IDs. Each ID's sortOrder = its index.
 */
export const useReorderCourses = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderCourses>>,
    TError,
    { data: BodyType<ReorderInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reorderCourses>>,
  TError,
  { data: BodyType<ReorderInput> },
  TContext
> => {
  return useMutation(getReorderCoursesMutationOptions(options));
};

/**
 * @summary Link a class to a course (M:N)
 */
export const getLinkCourseClassUrl = (courseId: number, classId: number) => {
  return `/api/courses/${courseId}/classes/${classId}`;
};

export const linkCourseClass = async (
  courseId: number,
  classId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getLinkCourseClassUrl(courseId, classId), {
    ...options,
    method: "POST",
  });
};

export const getLinkCourseClassMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof linkCourseClass>>,
    TError,
    { courseId: number; classId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof linkCourseClass>>,
  TError,
  { courseId: number; classId: number },
  TContext
> => {
  const mutationKey = ["linkCourseClass"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof linkCourseClass>>,
    { courseId: number; classId: number }
  > = (props) => {
    const { courseId, classId } = props ?? {};

    return linkCourseClass(courseId, classId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LinkCourseClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof linkCourseClass>>
>;

export type LinkCourseClassMutationError = ErrorType<unknown>;

/**
 * @summary Link a class to a course (M:N)
 */
export const useLinkCourseClass = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof linkCourseClass>>,
    TError,
    { courseId: number; classId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof linkCourseClass>>,
  TError,
  { courseId: number; classId: number },
  TContext
> => {
  return useMutation(getLinkCourseClassMutationOptions(options));
};

/**
 * @summary Unlink a class from a course
 */
export const getUnlinkCourseClassUrl = (courseId: number, classId: number) => {
  return `/api/courses/${courseId}/classes/${classId}`;
};

export const unlinkCourseClass = async (
  courseId: number,
  classId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getUnlinkCourseClassUrl(courseId, classId), {
    ...options,
    method: "DELETE",
  });
};

export const getUnlinkCourseClassMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlinkCourseClass>>,
    TError,
    { courseId: number; classId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlinkCourseClass>>,
  TError,
  { courseId: number; classId: number },
  TContext
> => {
  const mutationKey = ["unlinkCourseClass"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlinkCourseClass>>,
    { courseId: number; classId: number }
  > = (props) => {
    const { courseId, classId } = props ?? {};

    return unlinkCourseClass(courseId, classId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlinkCourseClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlinkCourseClass>>
>;

export type UnlinkCourseClassMutationError = ErrorType<unknown>;

/**
 * @summary Unlink a class from a course
 */
export const useUnlinkCourseClass = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlinkCourseClass>>,
    TError,
    { courseId: number; classId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlinkCourseClass>>,
  TError,
  { courseId: number; classId: number },
  TContext
> => {
  return useMutation(getUnlinkCourseClassMutationOptions(options));
};

/**
 * @summary Get students in a class
 */
export const getGetClassStudentsUrl = (classId: number) => {
  return `/api/classes/${classId}/students`;
};

export const getClassStudents = async (
  classId: number,
  options?: RequestInit,
): Promise<Student[]> => {
  return customFetch<Student[]>(getGetClassStudentsUrl(classId), {
    ...options,
    method: "GET",
  });
};

export const getGetClassStudentsQueryKey = (classId: number) => {
  return [`/api/classes/${classId}/students`] as const;
};

export const getGetClassStudentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassStudents>>,
  TError = ErrorType<unknown>,
>(
  classId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassStudents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClassStudentsQueryKey(classId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassStudents>>
  > = ({ signal }) => getClassStudents(classId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!classId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassStudents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetClassStudentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassStudents>>
>;
export type GetClassStudentsQueryError = ErrorType<unknown>;

/**
 * @summary Get students in a class
 */

export function useGetClassStudents<
  TData = Awaited<ReturnType<typeof getClassStudents>>,
  TError = ErrorType<unknown>,
>(
  classId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassStudents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetClassStudentsQueryOptions(classId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Add student to class
 */
export const getAddStudentToClassUrl = (classId: number) => {
  return `/api/classes/${classId}/students`;
};

export const addStudentToClass = async (
  classId: number,
  addStudentToClassBody: AddStudentToClassBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getAddStudentToClassUrl(classId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addStudentToClassBody),
  });
};

export const getAddStudentToClassMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addStudentToClass>>,
    TError,
    { classId: number; data: BodyType<AddStudentToClassBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addStudentToClass>>,
  TError,
  { classId: number; data: BodyType<AddStudentToClassBody> },
  TContext
> => {
  const mutationKey = ["addStudentToClass"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addStudentToClass>>,
    { classId: number; data: BodyType<AddStudentToClassBody> }
  > = (props) => {
    const { classId, data } = props ?? {};

    return addStudentToClass(classId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddStudentToClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof addStudentToClass>>
>;
export type AddStudentToClassMutationBody = BodyType<AddStudentToClassBody>;
export type AddStudentToClassMutationError = ErrorType<unknown>;

/**
 * @summary Add student to class
 */
export const useAddStudentToClass = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addStudentToClass>>,
    TError,
    { classId: number; data: BodyType<AddStudentToClassBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addStudentToClass>>,
  TError,
  { classId: number; data: BodyType<AddStudentToClassBody> },
  TContext
> => {
  return useMutation(getAddStudentToClassMutationOptions(options));
};

/**
 * @summary Remove student from class
 */
export const getRemoveStudentFromClassUrl = (
  classId: number,
  studentId: number,
) => {
  return `/api/classes/${classId}/students/${studentId}`;
};

export const removeStudentFromClass = async (
  classId: number,
  studentId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getRemoveStudentFromClassUrl(classId, studentId), {
    ...options,
    method: "DELETE",
  });
};

export const getRemoveStudentFromClassMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeStudentFromClass>>,
    TError,
    { classId: number; studentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeStudentFromClass>>,
  TError,
  { classId: number; studentId: number },
  TContext
> => {
  const mutationKey = ["removeStudentFromClass"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeStudentFromClass>>,
    { classId: number; studentId: number }
  > = (props) => {
    const { classId, studentId } = props ?? {};

    return removeStudentFromClass(classId, studentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveStudentFromClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeStudentFromClass>>
>;

export type RemoveStudentFromClassMutationError = ErrorType<unknown>;

/**
 * @summary Remove student from class
 */
export const useRemoveStudentFromClass = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeStudentFromClass>>,
    TError,
    { classId: number; studentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeStudentFromClass>>,
  TError,
  { classId: number; studentId: number },
  TContext
> => {
  return useMutation(getRemoveStudentFromClassMutationOptions(options));
};

/**
 * @summary Get diary entries for a date range
 */
export const getGetDiaryEntriesUrl = (params: GetDiaryEntriesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/diary?${stringifiedParams}`
    : `/api/diary`;
};

export const getDiaryEntries = async (
  params: GetDiaryEntriesParams,
  options?: RequestInit,
): Promise<DiaryEntry[]> => {
  return customFetch<DiaryEntry[]>(getGetDiaryEntriesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetDiaryEntriesQueryKey = (params?: GetDiaryEntriesParams) => {
  return [`/api/diary`, ...(params ? [params] : [])] as const;
};

export const getGetDiaryEntriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getDiaryEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetDiaryEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDiaryEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDiaryEntriesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDiaryEntries>>> = ({
    signal,
  }) => getDiaryEntries(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDiaryEntries>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDiaryEntriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDiaryEntries>>
>;
export type GetDiaryEntriesQueryError = ErrorType<unknown>;

/**
 * @summary Get diary entries for a date range
 */

export function useGetDiaryEntries<
  TData = Awaited<ReturnType<typeof getDiaryEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetDiaryEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDiaryEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDiaryEntriesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the teacher's own diary entries matching an optional text query
and/or date range. Does NOT require a timetableId — designed for the
Program Registration diary-picker so teachers can find entries without
knowing which timetable they came from.
Results are capped at `limit` (max 50) and ordered newest-first.

 * @summary Search diary entries across all timetables (for program registration linking)
 */
export const getSearchDiaryEntriesUrl = (params?: SearchDiaryEntriesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/diary/search?${stringifiedParams}`
    : `/api/diary/search`;
};

export const searchDiaryEntries = async (
  params?: SearchDiaryEntriesParams,
  options?: RequestInit,
): Promise<SearchDiaryEntries200> => {
  return customFetch<SearchDiaryEntries200>(getSearchDiaryEntriesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getSearchDiaryEntriesQueryKey = (
  params?: SearchDiaryEntriesParams,
) => {
  return [`/api/diary/search`, ...(params ? [params] : [])] as const;
};

export const getSearchDiaryEntriesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchDiaryEntries>>,
  TError = ErrorType<unknown>,
>(
  params?: SearchDiaryEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDiaryEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchDiaryEntriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchDiaryEntries>>
  > = ({ signal }) => searchDiaryEntries(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchDiaryEntries>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchDiaryEntriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchDiaryEntries>>
>;
export type SearchDiaryEntriesQueryError = ErrorType<unknown>;

/**
 * @summary Search diary entries across all timetables (for program registration linking)
 */

export function useSearchDiaryEntries<
  TData = Awaited<ReturnType<typeof searchDiaryEntries>>,
  TError = ErrorType<unknown>,
>(
  params?: SearchDiaryEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchDiaryEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSearchDiaryEntriesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save/update a diary slot entry
 */
export const getSaveDiarySlotUrl = (date: string, slotKey: string) => {
  return `/api/diary/${date}/slots/${slotKey}`;
};

export const saveDiarySlot = async (
  date: string,
  slotKey: string,
  diarySlotInput: DiarySlotInput,
  options?: RequestInit,
): Promise<DiaryEntry> => {
  return customFetch<DiaryEntry>(getSaveDiarySlotUrl(date, slotKey), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(diarySlotInput),
  });
};

export const getSaveDiarySlotMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveDiarySlot>>,
    TError,
    { date: string; slotKey: string; data: BodyType<DiarySlotInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveDiarySlot>>,
  TError,
  { date: string; slotKey: string; data: BodyType<DiarySlotInput> },
  TContext
> => {
  const mutationKey = ["saveDiarySlot"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveDiarySlot>>,
    { date: string; slotKey: string; data: BodyType<DiarySlotInput> }
  > = (props) => {
    const { date, slotKey, data } = props ?? {};

    return saveDiarySlot(date, slotKey, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveDiarySlotMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveDiarySlot>>
>;
export type SaveDiarySlotMutationBody = BodyType<DiarySlotInput>;
export type SaveDiarySlotMutationError = ErrorType<unknown>;

/**
 * @summary Save/update a diary slot entry
 */
export const useSaveDiarySlot = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveDiarySlot>>,
    TError,
    { date: string; slotKey: string; data: BodyType<DiarySlotInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveDiarySlot>>,
  TError,
  { date: string; slotKey: string; data: BodyType<DiarySlotInput> },
  TContext
> => {
  return useMutation(getSaveDiarySlotMutationOptions(options));
};

/**
 * @summary Save top-level day notes for a diary date
 */
export const getSaveDiaryDayNotesUrl = (date: string) => {
  return `/api/diary/${date}/notes`;
};

export const saveDiaryDayNotes = async (
  date: string,
  saveDiaryDayNotesBody: SaveDiaryDayNotesBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getSaveDiaryDayNotesUrl(date), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(saveDiaryDayNotesBody),
  });
};

export const getSaveDiaryDayNotesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveDiaryDayNotes>>,
    TError,
    { date: string; data: BodyType<SaveDiaryDayNotesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveDiaryDayNotes>>,
  TError,
  { date: string; data: BodyType<SaveDiaryDayNotesBody> },
  TContext
> => {
  const mutationKey = ["saveDiaryDayNotes"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveDiaryDayNotes>>,
    { date: string; data: BodyType<SaveDiaryDayNotesBody> }
  > = (props) => {
    const { date, data } = props ?? {};

    return saveDiaryDayNotes(date, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveDiaryDayNotesMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveDiaryDayNotes>>
>;
export type SaveDiaryDayNotesMutationBody = BodyType<SaveDiaryDayNotesBody>;
export type SaveDiaryDayNotesMutationError = ErrorType<unknown>;

/**
 * @summary Save top-level day notes for a diary date
 */
export const useSaveDiaryDayNotes = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveDiaryDayNotes>>,
    TError,
    { date: string; data: BodyType<SaveDiaryDayNotesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveDiaryDayNotes>>,
  TError,
  { date: string; data: BodyType<SaveDiaryDayNotesBody> },
  TContext
> => {
  return useMutation(getSaveDiaryDayNotesMutationOptions(options));
};

/**
 * @summary List all daily timetable overrides in a date range (inclusive)
 */
export const getListDailyOverridesUrl = (params: ListDailyOverridesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/diary/overrides?${stringifiedParams}`
    : `/api/diary/overrides`;
};

export const listDailyOverrides = async (
  params: ListDailyOverridesParams,
  options?: RequestInit,
): Promise<DailyOverride[]> => {
  return customFetch<DailyOverride[]>(getListDailyOverridesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListDailyOverridesQueryKey = (
  params?: ListDailyOverridesParams,
) => {
  return [`/api/diary/overrides`, ...(params ? [params] : [])] as const;
};

export const getListDailyOverridesQueryOptions = <
  TData = Awaited<ReturnType<typeof listDailyOverrides>>,
  TError = ErrorType<unknown>,
>(
  params: ListDailyOverridesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDailyOverrides>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListDailyOverridesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDailyOverrides>>
  > = ({ signal }) => listDailyOverrides(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDailyOverrides>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDailyOverridesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDailyOverrides>>
>;
export type ListDailyOverridesQueryError = ErrorType<unknown>;

/**
 * @summary List all daily timetable overrides in a date range (inclusive)
 */

export function useListDailyOverrides<
  TData = Awaited<ReturnType<typeof listDailyOverrides>>,
  TError = ErrorType<unknown>,
>(
  params: ListDailyOverridesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDailyOverrides>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListDailyOverridesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get the daily timetable override for a specific date (or null if none exists)
 */
export const getGetDailyOverrideUrl = (date: string) => {
  return `/api/diary/${date}/override`;
};

export const getDailyOverride = async (
  date: string,
  options?: RequestInit,
): Promise<DailyOverrideResponse | null> => {
  return customFetch<DailyOverrideResponse | null>(
    getGetDailyOverrideUrl(date),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetDailyOverrideQueryKey = (date: string) => {
  return [`/api/diary/${date}/override`] as const;
};

export const getGetDailyOverrideQueryOptions = <
  TData = Awaited<ReturnType<typeof getDailyOverride>>,
  TError = ErrorType<unknown>,
>(
  date: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyOverride>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDailyOverrideQueryKey(date);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDailyOverride>>
  > = ({ signal }) => getDailyOverride(date, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!date,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDailyOverride>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDailyOverrideQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDailyOverride>>
>;
export type GetDailyOverrideQueryError = ErrorType<unknown>;

/**
 * @summary Get the daily timetable override for a specific date (or null if none exists)
 */

export function useGetDailyOverride<
  TData = Awaited<ReturnType<typeof getDailyOverride>>,
  TError = ErrorType<unknown>,
>(
  date: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyOverride>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDailyOverrideQueryOptions(date, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create or replace the daily timetable override for a specific date
 */
export const getSaveDailyOverrideUrl = (date: string) => {
  return `/api/diary/${date}/override`;
};

export const saveDailyOverride = async (
  date: string,
  dailyOverrideInput: DailyOverrideInput,
  options?: RequestInit,
): Promise<DailyOverride> => {
  return customFetch<DailyOverride>(getSaveDailyOverrideUrl(date), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(dailyOverrideInput),
  });
};

export const getSaveDailyOverrideMutationOptions = <
  TError = ErrorType<DailyOverrideError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveDailyOverride>>,
    TError,
    { date: string; data: BodyType<DailyOverrideInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveDailyOverride>>,
  TError,
  { date: string; data: BodyType<DailyOverrideInput> },
  TContext
> => {
  const mutationKey = ["saveDailyOverride"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveDailyOverride>>,
    { date: string; data: BodyType<DailyOverrideInput> }
  > = (props) => {
    const { date, data } = props ?? {};

    return saveDailyOverride(date, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveDailyOverrideMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveDailyOverride>>
>;
export type SaveDailyOverrideMutationBody = BodyType<DailyOverrideInput>;
export type SaveDailyOverrideMutationError = ErrorType<DailyOverrideError>;

/**
 * @summary Create or replace the daily timetable override for a specific date
 */
export const useSaveDailyOverride = <
  TError = ErrorType<DailyOverrideError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveDailyOverride>>,
    TError,
    { date: string; data: BodyType<DailyOverrideInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveDailyOverride>>,
  TError,
  { date: string; data: BodyType<DailyOverrideInput> },
  TContext
> => {
  return useMutation(getSaveDailyOverrideMutationOptions(options));
};

/**
 * @summary Clear the daily timetable override for a specific date
 */
export const getDeleteDailyOverrideUrl = (date: string) => {
  return `/api/diary/${date}/override`;
};

export const deleteDailyOverride = async (
  date: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteDailyOverrideUrl(date), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteDailyOverrideMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDailyOverride>>,
    TError,
    { date: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDailyOverride>>,
  TError,
  { date: string },
  TContext
> => {
  const mutationKey = ["deleteDailyOverride"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDailyOverride>>,
    { date: string }
  > = (props) => {
    const { date } = props ?? {};

    return deleteDailyOverride(date, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDailyOverrideMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDailyOverride>>
>;

export type DeleteDailyOverrideMutationError = ErrorType<unknown>;

/**
 * @summary Clear the daily timetable override for a specific date
 */
export const useDeleteDailyOverride = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDailyOverride>>,
    TError,
    { date: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteDailyOverride>>,
  TError,
  { date: string },
  TContext
> => {
  return useMutation(getDeleteDailyOverrideMutationOptions(options));
};

/**
 * @summary List structured records with filters
 */
export const getListRecordsUrl = (params?: ListRecordsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/records?${stringifiedParams}`
    : `/api/records`;
};

export const listRecords = async (
  params?: ListRecordsParams,
  options?: RequestInit,
): Promise<Record[]> => {
  return customFetch<Record[]>(getListRecordsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListRecordsQueryKey = (params?: ListRecordsParams) => {
  return [`/api/records`, ...(params ? [params] : [])] as const;
};

export const getListRecordsQueryOptions = <
  TData = Awaited<ReturnType<typeof listRecords>>,
  TError = ErrorType<unknown>,
>(
  params?: ListRecordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listRecords>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListRecordsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecords>>> = ({
    signal,
  }) => listRecords(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listRecords>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListRecordsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRecords>>
>;
export type ListRecordsQueryError = ErrorType<unknown>;

/**
 * @summary List structured records with filters
 */

export function useListRecords<
  TData = Awaited<ReturnType<typeof listRecords>>,
  TError = ErrorType<unknown>,
>(
  params?: ListRecordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listRecords>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListRecordsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a structured record
 */
export const getCreateRecordUrl = () => {
  return `/api/records`;
};

export const createRecord = async (
  recordInput: RecordInput,
  options?: RequestInit,
): Promise<Record> => {
  return customFetch<Record>(getCreateRecordUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(recordInput),
  });
};

export const getCreateRecordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRecord>>,
    TError,
    { data: BodyType<RecordInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRecord>>,
  TError,
  { data: BodyType<RecordInput> },
  TContext
> => {
  const mutationKey = ["createRecord"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRecord>>,
    { data: BodyType<RecordInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createRecord(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRecordMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRecord>>
>;
export type CreateRecordMutationBody = BodyType<RecordInput>;
export type CreateRecordMutationError = ErrorType<unknown>;

/**
 * @summary Create a structured record
 */
export const useCreateRecord = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRecord>>,
    TError,
    { data: BodyType<RecordInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createRecord>>,
  TError,
  { data: BodyType<RecordInput> },
  TContext
> => {
  return useMutation(getCreateRecordMutationOptions(options));
};

/**
 * @summary Get a single record
 */
export const getGetRecordUrl = (recordId: number) => {
  return `/api/records/${recordId}`;
};

export const getRecord = async (
  recordId: number,
  options?: RequestInit,
): Promise<Record> => {
  return customFetch<Record>(getGetRecordUrl(recordId), {
    ...options,
    method: "GET",
  });
};

export const getGetRecordQueryKey = (recordId: number) => {
  return [`/api/records/${recordId}`] as const;
};

export const getGetRecordQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecord>>,
  TError = ErrorType<unknown>,
>(
  recordId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRecord>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRecordQueryKey(recordId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecord>>> = ({
    signal,
  }) => getRecord(recordId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!recordId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getRecord>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetRecordQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecord>>
>;
export type GetRecordQueryError = ErrorType<unknown>;

/**
 * @summary Get a single record
 */

export function useGetRecord<
  TData = Awaited<ReturnType<typeof getRecord>>,
  TError = ErrorType<unknown>,
>(
  recordId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRecord>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRecordQueryOptions(recordId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a record
 */
export const getUpdateRecordUrl = (recordId: number) => {
  return `/api/records/${recordId}`;
};

export const updateRecord = async (
  recordId: number,
  recordInput: RecordInput,
  options?: RequestInit,
): Promise<Record> => {
  return customFetch<Record>(getUpdateRecordUrl(recordId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(recordInput),
  });
};

export const getUpdateRecordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRecord>>,
    TError,
    { recordId: number; data: BodyType<RecordInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRecord>>,
  TError,
  { recordId: number; data: BodyType<RecordInput> },
  TContext
> => {
  const mutationKey = ["updateRecord"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRecord>>,
    { recordId: number; data: BodyType<RecordInput> }
  > = (props) => {
    const { recordId, data } = props ?? {};

    return updateRecord(recordId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRecordMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRecord>>
>;
export type UpdateRecordMutationBody = BodyType<RecordInput>;
export type UpdateRecordMutationError = ErrorType<unknown>;

/**
 * @summary Update a record
 */
export const useUpdateRecord = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRecord>>,
    TError,
    { recordId: number; data: BodyType<RecordInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateRecord>>,
  TError,
  { recordId: number; data: BodyType<RecordInput> },
  TContext
> => {
  return useMutation(getUpdateRecordMutationOptions(options));
};

/**
 * @summary Delete a record
 */
export const getDeleteRecordUrl = (recordId: number) => {
  return `/api/records/${recordId}`;
};

export const deleteRecord = async (
  recordId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteRecordUrl(recordId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteRecordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRecord>>,
    TError,
    { recordId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRecord>>,
  TError,
  { recordId: number },
  TContext
> => {
  const mutationKey = ["deleteRecord"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRecord>>,
    { recordId: number }
  > = (props) => {
    const { recordId } = props ?? {};

    return deleteRecord(recordId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRecordMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRecord>>
>;

export type DeleteRecordMutationError = ErrorType<unknown>;

/**
 * @summary Delete a record
 */
export const useDeleteRecord = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRecord>>,
    TError,
    { recordId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteRecord>>,
  TError,
  { recordId: number },
  TContext
> => {
  return useMutation(getDeleteRecordMutationOptions(options));
};

/**
 * @summary Toggle the "entered into school system" flag on a record
 */
export const getSetRecordEnteredUrl = (recordId: number) => {
  return `/api/records/${recordId}/entered`;
};

export const setRecordEntered = async (
  recordId: number,
  setRecordEnteredInput: SetRecordEnteredInput,
  options?: RequestInit,
): Promise<Record> => {
  return customFetch<Record>(getSetRecordEnteredUrl(recordId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setRecordEnteredInput),
  });
};

export const getSetRecordEnteredMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setRecordEntered>>,
    TError,
    { recordId: number; data: BodyType<SetRecordEnteredInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setRecordEntered>>,
  TError,
  { recordId: number; data: BodyType<SetRecordEnteredInput> },
  TContext
> => {
  const mutationKey = ["setRecordEntered"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setRecordEntered>>,
    { recordId: number; data: BodyType<SetRecordEnteredInput> }
  > = (props) => {
    const { recordId, data } = props ?? {};

    return setRecordEntered(recordId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetRecordEnteredMutationResult = NonNullable<
  Awaited<ReturnType<typeof setRecordEntered>>
>;
export type SetRecordEnteredMutationBody = BodyType<SetRecordEnteredInput>;
export type SetRecordEnteredMutationError = ErrorType<unknown>;

/**
 * @summary Toggle the "entered into school system" flag on a record
 */
export const useSetRecordEntered = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setRecordEntered>>,
    TError,
    { recordId: number; data: BodyType<SetRecordEnteredInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setRecordEntered>>,
  TError,
  { recordId: number; data: BodyType<SetRecordEnteredInput> },
  TContext
> => {
  return useMutation(getSetRecordEnteredMutationOptions(options));
};

/**
 * @summary List classes available for the markbook
 */
export const getListMarkbookClassesUrl = (
  params?: ListMarkbookClassesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/markbook/classes?${stringifiedParams}`
    : `/api/markbook/classes`;
};

export const listMarkbookClasses = async (
  params?: ListMarkbookClassesParams,
  options?: RequestInit,
): Promise<Class[]> => {
  return customFetch<Class[]>(getListMarkbookClassesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListMarkbookClassesQueryKey = (
  params?: ListMarkbookClassesParams,
) => {
  return [`/api/markbook/classes`, ...(params ? [params] : [])] as const;
};

export const getListMarkbookClassesQueryOptions = <
  TData = Awaited<ReturnType<typeof listMarkbookClasses>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMarkbookClassesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMarkbookClasses>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMarkbookClassesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMarkbookClasses>>
  > = ({ signal }) =>
    listMarkbookClasses(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMarkbookClasses>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMarkbookClassesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMarkbookClasses>>
>;
export type ListMarkbookClassesQueryError = ErrorType<unknown>;

/**
 * @summary List classes available for the markbook
 */

export function useListMarkbookClasses<
  TData = Awaited<ReturnType<typeof listMarkbookClasses>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMarkbookClassesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMarkbookClasses>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMarkbookClassesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a class's markbook (students, assessments and marks)
 */
export const getGetMarkbookUrl = (params: GetMarkbookParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/markbook?${stringifiedParams}`
    : `/api/markbook`;
};

export const getMarkbook = async (
  params: GetMarkbookParams,
  options?: RequestInit,
): Promise<MarkbookView> => {
  return customFetch<MarkbookView>(getGetMarkbookUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetMarkbookQueryKey = (params?: GetMarkbookParams) => {
  return [`/api/markbook`, ...(params ? [params] : [])] as const;
};

export const getGetMarkbookQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarkbook>>,
  TError = ErrorType<unknown>,
>(
  params: GetMarkbookParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarkbook>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarkbookQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarkbook>>> = ({
    signal,
  }) => getMarkbook(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarkbook>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMarkbookQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarkbook>>
>;
export type GetMarkbookQueryError = ErrorType<unknown>;

/**
 * @summary Get a class's markbook (students, assessments and marks)
 */

export function useGetMarkbook<
  TData = Awaited<ReturnType<typeof getMarkbook>>,
  TError = ErrorType<unknown>,
>(
  params: GetMarkbookParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarkbook>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMarkbookQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a markbook assessment for a class
 */
export const getCreateMarkbookAssessmentUrl = () => {
  return `/api/markbook/assessments`;
};

export const createMarkbookAssessment = async (
  createMarkbookAssessmentInput: CreateMarkbookAssessmentInput,
  options?: RequestInit,
): Promise<MarkbookAssessment> => {
  return customFetch<MarkbookAssessment>(getCreateMarkbookAssessmentUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createMarkbookAssessmentInput),
  });
};

export const getCreateMarkbookAssessmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMarkbookAssessment>>,
    TError,
    { data: BodyType<CreateMarkbookAssessmentInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMarkbookAssessment>>,
  TError,
  { data: BodyType<CreateMarkbookAssessmentInput> },
  TContext
> => {
  const mutationKey = ["createMarkbookAssessment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMarkbookAssessment>>,
    { data: BodyType<CreateMarkbookAssessmentInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createMarkbookAssessment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMarkbookAssessmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMarkbookAssessment>>
>;
export type CreateMarkbookAssessmentMutationBody =
  BodyType<CreateMarkbookAssessmentInput>;
export type CreateMarkbookAssessmentMutationError = ErrorType<unknown>;

/**
 * @summary Create a markbook assessment for a class
 */
export const useCreateMarkbookAssessment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMarkbookAssessment>>,
    TError,
    { data: BodyType<CreateMarkbookAssessmentInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMarkbookAssessment>>,
  TError,
  { data: BodyType<CreateMarkbookAssessmentInput> },
  TContext
> => {
  return useMutation(getCreateMarkbookAssessmentMutationOptions(options));
};

/**
 * @summary Delete a markbook assessment and its marks
 */
export const getDeleteMarkbookAssessmentUrl = (assessmentId: number) => {
  return `/api/markbook/assessments/${assessmentId}`;
};

export const deleteMarkbookAssessment = async (
  assessmentId: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getDeleteMarkbookAssessmentUrl(assessmentId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMarkbookAssessmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMarkbookAssessment>>,
    TError,
    { assessmentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMarkbookAssessment>>,
  TError,
  { assessmentId: number },
  TContext
> => {
  const mutationKey = ["deleteMarkbookAssessment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMarkbookAssessment>>,
    { assessmentId: number }
  > = (props) => {
    const { assessmentId } = props ?? {};

    return deleteMarkbookAssessment(assessmentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMarkbookAssessmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMarkbookAssessment>>
>;

export type DeleteMarkbookAssessmentMutationError = ErrorType<unknown>;

/**
 * @summary Delete a markbook assessment and its marks
 */
export const useDeleteMarkbookAssessment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMarkbookAssessment>>,
    TError,
    { assessmentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMarkbookAssessment>>,
  TError,
  { assessmentId: number },
  TContext
> => {
  return useMutation(getDeleteMarkbookAssessmentMutationOptions(options));
};

/**
 * @summary Upsert a single student's mark for an assessment
 */
export const getUpsertMarkbookMarkUrl = () => {
  return `/api/markbook/marks`;
};

export const upsertMarkbookMark = async (
  upsertMarkbookMarkInput: UpsertMarkbookMarkInput,
  options?: RequestInit,
): Promise<MarkbookMark> => {
  return customFetch<MarkbookMark>(getUpsertMarkbookMarkUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(upsertMarkbookMarkInput),
  });
};

export const getUpsertMarkbookMarkMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertMarkbookMark>>,
    TError,
    { data: BodyType<UpsertMarkbookMarkInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertMarkbookMark>>,
  TError,
  { data: BodyType<UpsertMarkbookMarkInput> },
  TContext
> => {
  const mutationKey = ["upsertMarkbookMark"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertMarkbookMark>>,
    { data: BodyType<UpsertMarkbookMarkInput> }
  > = (props) => {
    const { data } = props ?? {};

    return upsertMarkbookMark(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertMarkbookMarkMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertMarkbookMark>>
>;
export type UpsertMarkbookMarkMutationBody = BodyType<UpsertMarkbookMarkInput>;
export type UpsertMarkbookMarkMutationError = ErrorType<unknown>;

/**
 * @summary Upsert a single student's mark for an assessment
 */
export const useUpsertMarkbookMark = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertMarkbookMark>>,
    TError,
    { data: BodyType<UpsertMarkbookMarkInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertMarkbookMark>>,
  TError,
  { data: BodyType<UpsertMarkbookMarkInput> },
  TContext
> => {
  return useMutation(getUpsertMarkbookMarkMutationOptions(options));
};

/**
 * @summary List all tasks
 */
export const getListTasksUrl = () => {
  return `/api/tasks`;
};

export const listTasks = async (options?: RequestInit): Promise<Task[]> => {
  return customFetch<Task[]>(getListTasksUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListTasksQueryKey = () => {
  return [`/api/tasks`] as const;
};

export const getListTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof listTasks>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTasksQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTasks>>> = ({
    signal,
  }) => listTasks({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTasks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTasks>>
>;
export type ListTasksQueryError = ErrorType<unknown>;

/**
 * @summary List all tasks
 */

export function useListTasks<
  TData = Awaited<ReturnType<typeof listTasks>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTasksQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a task
 */
export const getCreateTaskUrl = () => {
  return `/api/tasks`;
};

export const createTask = async (
  taskInput: TaskInput,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getCreateTaskUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(taskInput),
  });
};

export const getCreateTaskMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTask>>,
    TError,
    { data: BodyType<TaskInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTask>>,
  TError,
  { data: BodyType<TaskInput> },
  TContext
> => {
  const mutationKey = ["createTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTask>>,
    { data: BodyType<TaskInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createTask(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTask>>
>;
export type CreateTaskMutationBody = BodyType<TaskInput>;
export type CreateTaskMutationError = ErrorType<unknown>;

/**
 * @summary Create a task
 */
export const useCreateTask = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTask>>,
    TError,
    { data: BodyType<TaskInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTask>>,
  TError,
  { data: BodyType<TaskInput> },
  TContext
> => {
  return useMutation(getCreateTaskMutationOptions(options));
};

/**
 * @summary Update a task (including toggle completion)
 */
export const getUpdateTaskUrl = (taskId: number) => {
  return `/api/tasks/${taskId}`;
};

export const updateTask = async (
  taskId: number,
  taskInput: TaskInput,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getUpdateTaskUrl(taskId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(taskInput),
  });
};

export const getUpdateTaskMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTask>>,
    TError,
    { taskId: number; data: BodyType<TaskInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTask>>,
  TError,
  { taskId: number; data: BodyType<TaskInput> },
  TContext
> => {
  const mutationKey = ["updateTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTask>>,
    { taskId: number; data: BodyType<TaskInput> }
  > = (props) => {
    const { taskId, data } = props ?? {};

    return updateTask(taskId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTask>>
>;
export type UpdateTaskMutationBody = BodyType<TaskInput>;
export type UpdateTaskMutationError = ErrorType<unknown>;

/**
 * @summary Update a task (including toggle completion)
 */
export const useUpdateTask = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTask>>,
    TError,
    { taskId: number; data: BodyType<TaskInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTask>>,
  TError,
  { taskId: number; data: BodyType<TaskInput> },
  TContext
> => {
  return useMutation(getUpdateTaskMutationOptions(options));
};

/**
 * @summary Delete a task
 */
export const getDeleteTaskUrl = (taskId: number) => {
  return `/api/tasks/${taskId}`;
};

export const deleteTask = async (
  taskId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteTaskUrl(taskId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTaskMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTask>>,
    TError,
    { taskId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTask>>,
  TError,
  { taskId: number },
  TContext
> => {
  const mutationKey = ["deleteTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTask>>,
    { taskId: number }
  > = (props) => {
    const { taskId } = props ?? {};

    return deleteTask(taskId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTask>>
>;

export type DeleteTaskMutationError = ErrorType<unknown>;

/**
 * @summary Delete a task
 */
export const useDeleteTask = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTask>>,
    TError,
    { taskId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTask>>,
  TError,
  { taskId: number },
  TContext
> => {
  return useMutation(getDeleteTaskMutationOptions(options));
};

/**
 * Returns the teacher's notes ordered by updated_at descending (newest first). Returns an empty array when the teacher has no notes yet.

 * @summary Get all note pages for the authenticated teacher
 */
export const getGetNotesUrl = () => {
  return `/api/notes`;
};

export const getNotes = async (options?: RequestInit): Promise<Notes[]> => {
  return customFetch<Notes[]>(getGetNotesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetNotesQueryKey = () => {
  return [`/api/notes`] as const;
};

export const getGetNotesQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getNotes>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotes>>> = ({
    signal,
  }) => getNotes({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotes>>
>;
export type GetNotesQueryError = ErrorType<unknown>;

/**
 * @summary Get all note pages for the authenticated teacher
 */

export function useGetNotes<
  TData = Awaited<ReturnType<typeof getNotes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getNotes>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNotesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates a note with title "Untitled note" and empty content. Guarded by the MULTI_NOTE_CREATION_ENABLED feature flag — returns 503 when the flag is off.

 * @summary Create a new note page
 */
export const getCreateNoteUrl = () => {
  return `/api/notes`;
};

export const createNote = async (options?: RequestInit): Promise<Notes> => {
  return customFetch<Notes>(getCreateNoteUrl(), {
    ...options,
    method: "POST",
  });
};

export const getCreateNoteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNote>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createNote>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["createNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createNote>>,
    void
  > = () => {
    return createNote(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof createNote>>
>;

export type CreateNoteMutationError = ErrorType<void>;

/**
 * @summary Create a new note page
 */
export const useCreateNote = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNote>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createNote>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCreateNoteMutationOptions(options));
};

/**
 * Updates the title and content of the authenticated teacher's note. Returns 404 if the note does not exist or belongs to another user.

 * @summary Update a note page by ID
 */
export const getUpdateNoteUrl = (noteId: number) => {
  return `/api/notes/${noteId}`;
};

export const updateNote = async (
  noteId: number,
  updateNoteBody: UpdateNoteBody,
  options?: RequestInit,
): Promise<Notes> => {
  return customFetch<Notes>(getUpdateNoteUrl(noteId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateNoteBody),
  });
};

export const getUpdateNoteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNote>>,
    TError,
    { noteId: number; data: BodyType<UpdateNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNote>>,
  TError,
  { noteId: number; data: BodyType<UpdateNoteBody> },
  TContext
> => {
  const mutationKey = ["updateNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNote>>,
    { noteId: number; data: BodyType<UpdateNoteBody> }
  > = (props) => {
    const { noteId, data } = props ?? {};

    return updateNote(noteId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNote>>
>;
export type UpdateNoteMutationBody = BodyType<UpdateNoteBody>;
export type UpdateNoteMutationError = ErrorType<void>;

/**
 * @summary Update a note page by ID
 */
export const useUpdateNote = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNote>>,
    TError,
    { noteId: number; data: BodyType<UpdateNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateNote>>,
  TError,
  { noteId: number; data: BodyType<UpdateNoteBody> },
  TContext
> => {
  return useMutation(getUpdateNoteMutationOptions(options));
};

/**
 * @summary List all exports
 */
export const getListExportsUrl = () => {
  return `/api/exports`;
};

export const listExports = async (options?: RequestInit): Promise<Export[]> => {
  return customFetch<Export[]>(getListExportsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListExportsQueryKey = () => {
  return [`/api/exports`] as const;
};

export const getListExportsQueryOptions = <
  TData = Awaited<ReturnType<typeof listExports>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listExports>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListExportsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listExports>>> = ({
    signal,
  }) => listExports({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listExports>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListExportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listExports>>
>;
export type ListExportsQueryError = ErrorType<unknown>;

/**
 * @summary List all exports
 */

export function useListExports<
  TData = Awaited<ReturnType<typeof listExports>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listExports>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListExportsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new export
 */
export const getCreateExportUrl = () => {
  return `/api/exports`;
};

export const createExport = async (
  exportInput: ExportInput,
  options?: RequestInit,
): Promise<Export> => {
  return customFetch<Export>(getCreateExportUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(exportInput),
  });
};

export const getCreateExportMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createExport>>,
    TError,
    { data: BodyType<ExportInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createExport>>,
  TError,
  { data: BodyType<ExportInput> },
  TContext
> => {
  const mutationKey = ["createExport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createExport>>,
    { data: BodyType<ExportInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createExport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateExportMutationResult = NonNullable<
  Awaited<ReturnType<typeof createExport>>
>;
export type CreateExportMutationBody = BodyType<ExportInput>;
export type CreateExportMutationError = ErrorType<unknown>;

/**
 * @summary Create a new export
 */
export const useCreateExport = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createExport>>,
    TError,
    { data: BodyType<ExportInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createExport>>,
  TError,
  { data: BodyType<ExportInput> },
  TContext
> => {
  return useMutation(getCreateExportMutationOptions(options));
};

/**
 * @summary Delete an export
 */
export const getDeleteExportUrl = (exportId: number) => {
  return `/api/exports/${exportId}`;
};

export const deleteExport = async (
  exportId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteExportUrl(exportId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteExportMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteExport>>,
    TError,
    { exportId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteExport>>,
  TError,
  { exportId: number },
  TContext
> => {
  const mutationKey = ["deleteExport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteExport>>,
    { exportId: number }
  > = (props) => {
    const { exportId } = props ?? {};

    return deleteExport(exportId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteExportMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteExport>>
>;

export type DeleteExportMutationError = ErrorType<unknown>;

/**
 * @summary Delete an export
 */
export const useDeleteExport = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteExport>>,
    TError,
    { exportId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteExport>>,
  TError,
  { exportId: number },
  TContext
> => {
  return useMutation(getDeleteExportMutationOptions(options));
};

/**
 * @summary Download a CSV of records (filtered by date range)
 */
export const getDownloadRecordsCsvUrl = (params?: DownloadRecordsCsvParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/exports/download.csv?${stringifiedParams}`
    : `/api/exports/download.csv`;
};

export const downloadRecordsCsv = async (
  params?: DownloadRecordsCsvParams,
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getDownloadRecordsCsvUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getDownloadRecordsCsvQueryKey = (
  params?: DownloadRecordsCsvParams,
) => {
  return [`/api/exports/download.csv`, ...(params ? [params] : [])] as const;
};

export const getDownloadRecordsCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadRecordsCsv>>,
  TError = ErrorType<unknown>,
>(
  params?: DownloadRecordsCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadRecordsCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadRecordsCsvQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadRecordsCsv>>
  > = ({ signal }) => downloadRecordsCsv(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadRecordsCsv>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadRecordsCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadRecordsCsv>>
>;
export type DownloadRecordsCsvQueryError = ErrorType<unknown>;

/**
 * @summary Download a CSV of records (filtered by date range)
 */

export function useDownloadRecordsCsv<
  TData = Awaited<ReturnType<typeof downloadRecordsCsv>>,
  TError = ErrorType<unknown>,
>(
  params?: DownloadRecordsCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadRecordsCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadRecordsCsvQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Download Sentral NCCD evidence log (per-record)
 */
export const getDownloadSentralNccdLogCsvUrl = (
  params?: DownloadSentralNccdLogCsvParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/exports/sentral-nccd-log.csv?${stringifiedParams}`
    : `/api/exports/sentral-nccd-log.csv`;
};

export const downloadSentralNccdLogCsv = async (
  params?: DownloadSentralNccdLogCsvParams,
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getDownloadSentralNccdLogCsvUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getDownloadSentralNccdLogCsvQueryKey = (
  params?: DownloadSentralNccdLogCsvParams,
) => {
  return [
    `/api/exports/sentral-nccd-log.csv`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDownloadSentralNccdLogCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadSentralNccdLogCsv>>,
  TError = ErrorType<unknown>,
>(
  params?: DownloadSentralNccdLogCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadSentralNccdLogCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadSentralNccdLogCsvQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadSentralNccdLogCsv>>
  > = ({ signal }) =>
    downloadSentralNccdLogCsv(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadSentralNccdLogCsv>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadSentralNccdLogCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadSentralNccdLogCsv>>
>;
export type DownloadSentralNccdLogCsvQueryError = ErrorType<unknown>;

/**
 * @summary Download Sentral NCCD evidence log (per-record)
 */

export function useDownloadSentralNccdLogCsv<
  TData = Awaited<ReturnType<typeof downloadSentralNccdLogCsv>>,
  TError = ErrorType<unknown>,
>(
  params?: DownloadSentralNccdLogCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadSentralNccdLogCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadSentralNccdLogCsvQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Download Sentral NCCD annual summary (per-student)
 */
export const getDownloadSentralNccdSummaryCsvUrl = (
  params?: DownloadSentralNccdSummaryCsvParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/exports/sentral-nccd-summary.csv?${stringifiedParams}`
    : `/api/exports/sentral-nccd-summary.csv`;
};

export const downloadSentralNccdSummaryCsv = async (
  params?: DownloadSentralNccdSummaryCsvParams,
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getDownloadSentralNccdSummaryCsvUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getDownloadSentralNccdSummaryCsvQueryKey = (
  params?: DownloadSentralNccdSummaryCsvParams,
) => {
  return [
    `/api/exports/sentral-nccd-summary.csv`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDownloadSentralNccdSummaryCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadSentralNccdSummaryCsv>>,
  TError = ErrorType<unknown>,
>(
  params?: DownloadSentralNccdSummaryCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadSentralNccdSummaryCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadSentralNccdSummaryCsvQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadSentralNccdSummaryCsv>>
  > = ({ signal }) =>
    downloadSentralNccdSummaryCsv(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadSentralNccdSummaryCsv>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadSentralNccdSummaryCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadSentralNccdSummaryCsv>>
>;
export type DownloadSentralNccdSummaryCsvQueryError = ErrorType<unknown>;

/**
 * @summary Download Sentral NCCD annual summary (per-student)
 */

export function useDownloadSentralNccdSummaryCsv<
  TData = Awaited<ReturnType<typeof downloadSentralNccdSummaryCsv>>,
  TError = ErrorType<unknown>,
>(
  params?: DownloadSentralNccdSummaryCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadSentralNccdSummaryCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadSentralNccdSummaryCsvQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns a small JSON sample of the same data the corresponding download
endpoint would emit. Used by the Generate Export modal so teachers can
spot identifier mistakes (e.g. a student with no code falling back to
initials) before clicking Generate.

 * @summary Preview the first few rows of a reduced-identifier export before generating
 */
export const getPreviewExportUrl = (params: PreviewExportParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/exports/preview?${stringifiedParams}`
    : `/api/exports/preview`;
};

export const previewExport = async (
  params: PreviewExportParams,
  options?: RequestInit,
): Promise<PreviewExport200> => {
  return customFetch<PreviewExport200>(getPreviewExportUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getPreviewExportQueryKey = (params?: PreviewExportParams) => {
  return [`/api/exports/preview`, ...(params ? [params] : [])] as const;
};

export const getPreviewExportQueryOptions = <
  TData = Awaited<ReturnType<typeof previewExport>>,
  TError = ErrorType<unknown>,
>(
  params: PreviewExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof previewExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPreviewExportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof previewExport>>> = ({
    signal,
  }) => previewExport(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof previewExport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PreviewExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof previewExport>>
>;
export type PreviewExportQueryError = ErrorType<unknown>;

/**
 * @summary Preview the first few rows of a reduced-identifier export before generating
 */

export function usePreviewExport<
  TData = Awaited<ReturnType<typeof previewExport>>,
  TError = ErrorType<unknown>,
>(
  params: PreviewExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof previewExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPreviewExportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns a small summary (day count, lesson count, record count, first/last
day labels) of the lessons HTML the corresponding download endpoint would
emit. Used by the Generate Export modal so teachers can confirm the date
range covers what they expect before clicking Generate. Built from the
same `collectLessonsData` pipeline as the file itself, so counts cannot
drift from the rendered HTML.

 * @summary Preview the size of a lesson-plan HTML export before generating
 */
export const getPreviewLessonsExportUrl = (
  params?: PreviewLessonsExportParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/exports/lessons-preview?${stringifiedParams}`
    : `/api/exports/lessons-preview`;
};

export const previewLessonsExport = async (
  params?: PreviewLessonsExportParams,
  options?: RequestInit,
): Promise<PreviewLessonsExport200> => {
  return customFetch<PreviewLessonsExport200>(
    getPreviewLessonsExportUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getPreviewLessonsExportQueryKey = (
  params?: PreviewLessonsExportParams,
) => {
  return [`/api/exports/lessons-preview`, ...(params ? [params] : [])] as const;
};

export const getPreviewLessonsExportQueryOptions = <
  TData = Awaited<ReturnType<typeof previewLessonsExport>>,
  TError = ErrorType<unknown>,
>(
  params?: PreviewLessonsExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof previewLessonsExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPreviewLessonsExportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof previewLessonsExport>>
  > = ({ signal }) =>
    previewLessonsExport(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof previewLessonsExport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PreviewLessonsExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof previewLessonsExport>>
>;
export type PreviewLessonsExportQueryError = ErrorType<unknown>;

/**
 * @summary Preview the size of a lesson-plan HTML export before generating
 */

export function usePreviewLessonsExport<
  TData = Awaited<ReturnType<typeof previewLessonsExport>>,
  TError = ErrorType<unknown>,
>(
  params?: PreviewLessonsExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof previewLessonsExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPreviewLessonsExportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Download lesson plans as HTML (printable)
 */
export const getDownloadLessonsHtmlUrl = (
  params?: DownloadLessonsHtmlParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/exports/lessons.html?${stringifiedParams}`
    : `/api/exports/lessons.html`;
};

export const downloadLessonsHtml = async (
  params?: DownloadLessonsHtmlParams,
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getDownloadLessonsHtmlUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getDownloadLessonsHtmlQueryKey = (
  params?: DownloadLessonsHtmlParams,
) => {
  return [`/api/exports/lessons.html`, ...(params ? [params] : [])] as const;
};

export const getDownloadLessonsHtmlQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadLessonsHtml>>,
  TError = ErrorType<unknown>,
>(
  params?: DownloadLessonsHtmlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadLessonsHtml>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadLessonsHtmlQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadLessonsHtml>>
  > = ({ signal }) =>
    downloadLessonsHtml(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadLessonsHtml>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadLessonsHtmlQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadLessonsHtml>>
>;
export type DownloadLessonsHtmlQueryError = ErrorType<unknown>;

/**
 * @summary Download lesson plans as HTML (printable)
 */

export function useDownloadLessonsHtml<
  TData = Awaited<ReturnType<typeof downloadLessonsHtml>>,
  TError = ErrorType<unknown>,
>(
  params?: DownloadLessonsHtmlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadLessonsHtml>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadLessonsHtmlQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List calendar events (optionally bounded by date range)
 */
export const getListCalendarEventsUrl = (params?: ListCalendarEventsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/events?${stringifiedParams}`
    : `/api/events`;
};

export const listCalendarEvents = async (
  params?: ListCalendarEventsParams,
  options?: RequestInit,
): Promise<CalendarEvent[]> => {
  return customFetch<CalendarEvent[]>(getListCalendarEventsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListCalendarEventsQueryKey = (
  params?: ListCalendarEventsParams,
) => {
  return [`/api/events`, ...(params ? [params] : [])] as const;
};

export const getListCalendarEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCalendarEvents>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCalendarEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCalendarEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCalendarEventsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCalendarEvents>>
  > = ({ signal }) => listCalendarEvents(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCalendarEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCalendarEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCalendarEvents>>
>;
export type ListCalendarEventsQueryError = ErrorType<unknown>;

/**
 * @summary List calendar events (optionally bounded by date range)
 */

export function useListCalendarEvents<
  TData = Awaited<ReturnType<typeof listCalendarEvents>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCalendarEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCalendarEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCalendarEventsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a calendar event
 */
export const getCreateCalendarEventUrl = () => {
  return `/api/events`;
};

export const createCalendarEvent = async (
  calendarEventInput: CalendarEventInput,
  options?: RequestInit,
): Promise<CalendarEvent> => {
  return customFetch<CalendarEvent>(getCreateCalendarEventUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(calendarEventInput),
  });
};

export const getCreateCalendarEventMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCalendarEvent>>,
    TError,
    { data: BodyType<CalendarEventInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCalendarEvent>>,
  TError,
  { data: BodyType<CalendarEventInput> },
  TContext
> => {
  const mutationKey = ["createCalendarEvent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCalendarEvent>>,
    { data: BodyType<CalendarEventInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createCalendarEvent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCalendarEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCalendarEvent>>
>;
export type CreateCalendarEventMutationBody = BodyType<CalendarEventInput>;
export type CreateCalendarEventMutationError = ErrorType<unknown>;

/**
 * @summary Create a calendar event
 */
export const useCreateCalendarEvent = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCalendarEvent>>,
    TError,
    { data: BodyType<CalendarEventInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCalendarEvent>>,
  TError,
  { data: BodyType<CalendarEventInput> },
  TContext
> => {
  return useMutation(getCreateCalendarEventMutationOptions(options));
};

/**
 * @summary Update a calendar event
 */
export const getUpdateCalendarEventUrl = (eventId: number) => {
  return `/api/events/${eventId}`;
};

export const updateCalendarEvent = async (
  eventId: number,
  updateCalendarEventInput: UpdateCalendarEventInput,
  options?: RequestInit,
): Promise<CalendarEvent> => {
  return customFetch<CalendarEvent>(getUpdateCalendarEventUrl(eventId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCalendarEventInput),
  });
};

export const getUpdateCalendarEventMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCalendarEvent>>,
    TError,
    { eventId: number; data: BodyType<UpdateCalendarEventInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCalendarEvent>>,
  TError,
  { eventId: number; data: BodyType<UpdateCalendarEventInput> },
  TContext
> => {
  const mutationKey = ["updateCalendarEvent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCalendarEvent>>,
    { eventId: number; data: BodyType<UpdateCalendarEventInput> }
  > = (props) => {
    const { eventId, data } = props ?? {};

    return updateCalendarEvent(eventId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCalendarEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCalendarEvent>>
>;
export type UpdateCalendarEventMutationBody =
  BodyType<UpdateCalendarEventInput>;
export type UpdateCalendarEventMutationError = ErrorType<unknown>;

/**
 * @summary Update a calendar event
 */
export const useUpdateCalendarEvent = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCalendarEvent>>,
    TError,
    { eventId: number; data: BodyType<UpdateCalendarEventInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCalendarEvent>>,
  TError,
  { eventId: number; data: BodyType<UpdateCalendarEventInput> },
  TContext
> => {
  return useMutation(getUpdateCalendarEventMutationOptions(options));
};

/**
 * @summary Delete a calendar event
 */
export const getDeleteCalendarEventUrl = (eventId: number) => {
  return `/api/events/${eventId}`;
};

export const deleteCalendarEvent = async (
  eventId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteCalendarEventUrl(eventId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCalendarEventMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCalendarEvent>>,
    TError,
    { eventId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCalendarEvent>>,
  TError,
  { eventId: number },
  TContext
> => {
  const mutationKey = ["deleteCalendarEvent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCalendarEvent>>,
    { eventId: number }
  > = (props) => {
    const { eventId } = props ?? {};

    return deleteCalendarEvent(eventId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCalendarEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCalendarEvent>>
>;

export type DeleteCalendarEventMutationError = ErrorType<unknown>;

/**
 * @summary Delete a calendar event
 */
export const useDeleteCalendarEvent = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCalendarEvent>>,
    TError,
    { eventId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCalendarEvent>>,
  TError,
  { eventId: number },
  TContext
> => {
  return useMutation(getDeleteCalendarEventMutationOptions(options));
};

/**
 * @summary Aggregated stats across all teachers at the head teacher's school
 */
export const getGetSchoolOverviewUrl = () => {
  return `/api/school/overview`;
};

export const getSchoolOverview = async (
  options?: RequestInit,
): Promise<SchoolOverview> => {
  return customFetch<SchoolOverview>(getGetSchoolOverviewUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSchoolOverviewQueryKey = () => {
  return [`/api/school/overview`] as const;
};

export const getGetSchoolOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getSchoolOverview>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSchoolOverview>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSchoolOverviewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSchoolOverview>>
  > = ({ signal }) => getSchoolOverview({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSchoolOverview>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSchoolOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSchoolOverview>>
>;
export type GetSchoolOverviewQueryError = ErrorType<unknown>;

/**
 * @summary Aggregated stats across all teachers at the head teacher's school
 */

export function useGetSchoolOverview<
  TData = Awaited<ReturnType<typeof getSchoolOverview>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSchoolOverview>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSchoolOverviewQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Drill into a specific teacher's records summary
 */
export const getGetSchoolTeacherUrl = (teacherUserId: string) => {
  return `/api/school/teacher/${teacherUserId}`;
};

export const getSchoolTeacher = async (
  teacherUserId: string,
  options?: RequestInit,
): Promise<SchoolTeacherDetail> => {
  return customFetch<SchoolTeacherDetail>(
    getGetSchoolTeacherUrl(teacherUserId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetSchoolTeacherQueryKey = (teacherUserId: string) => {
  return [`/api/school/teacher/${teacherUserId}`] as const;
};

export const getGetSchoolTeacherQueryOptions = <
  TData = Awaited<ReturnType<typeof getSchoolTeacher>>,
  TError = ErrorType<unknown>,
>(
  teacherUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSchoolTeacher>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSchoolTeacherQueryKey(teacherUserId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSchoolTeacher>>
  > = ({ signal }) =>
    getSchoolTeacher(teacherUserId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!teacherUserId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSchoolTeacher>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSchoolTeacherQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSchoolTeacher>>
>;
export type GetSchoolTeacherQueryError = ErrorType<unknown>;

/**
 * @summary Drill into a specific teacher's records summary
 */

export function useGetSchoolTeacher<
  TData = Awaited<ReturnType<typeof getSchoolTeacher>>,
  TError = ErrorType<unknown>,
>(
  teacherUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSchoolTeacher>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSchoolTeacherQueryOptions(teacherUserId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all teachers/staff in the head teacher's school
 */
export const getListSchoolTeachersUrl = () => {
  return `/api/school/teachers`;
};

export const listSchoolTeachers = async (
  options?: RequestInit,
): Promise<SchoolTeacherListItem[]> => {
  return customFetch<SchoolTeacherListItem[]>(getListSchoolTeachersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSchoolTeachersQueryKey = () => {
  return [`/api/school/teachers`] as const;
};

export const getListSchoolTeachersQueryOptions = <
  TData = Awaited<ReturnType<typeof listSchoolTeachers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listSchoolTeachers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSchoolTeachersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSchoolTeachers>>
  > = ({ signal }) => listSchoolTeachers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSchoolTeachers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSchoolTeachersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSchoolTeachers>>
>;
export type ListSchoolTeachersQueryError = ErrorType<unknown>;

/**
 * @summary List all teachers/staff in the head teacher's school
 */

export function useListSchoolTeachers<
  TData = Awaited<ReturnType<typeof listSchoolTeachers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listSchoolTeachers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSchoolTeachersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List teacher → class assignments for the school
 */
export const getListTeacherAssignmentsUrl = () => {
  return `/api/school/teacher-assignments`;
};

export const listTeacherAssignments = async (
  options?: RequestInit,
): Promise<TeacherAssignment[]> => {
  return customFetch<TeacherAssignment[]>(getListTeacherAssignmentsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListTeacherAssignmentsQueryKey = () => {
  return [`/api/school/teacher-assignments`] as const;
};

export const getListTeacherAssignmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listTeacherAssignments>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listTeacherAssignments>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListTeacherAssignmentsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTeacherAssignments>>
  > = ({ signal }) => listTeacherAssignments({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTeacherAssignments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTeacherAssignmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTeacherAssignments>>
>;
export type ListTeacherAssignmentsQueryError = ErrorType<unknown>;

/**
 * @summary List teacher → class assignments for the school
 */

export function useListTeacherAssignments<
  TData = Awaited<ReturnType<typeof listTeacherAssignments>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listTeacherAssignments>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTeacherAssignmentsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Replace the class assignments for a single teacher
 */
export const getSetTeacherAssignmentsUrl = () => {
  return `/api/school/teacher-assignments`;
};

export const setTeacherAssignments = async (
  setTeacherAssignmentInput: SetTeacherAssignmentInput,
  options?: RequestInit,
): Promise<TeacherAssignment> => {
  return customFetch<TeacherAssignment>(getSetTeacherAssignmentsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setTeacherAssignmentInput),
  });
};

export const getSetTeacherAssignmentsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setTeacherAssignments>>,
    TError,
    { data: BodyType<SetTeacherAssignmentInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setTeacherAssignments>>,
  TError,
  { data: BodyType<SetTeacherAssignmentInput> },
  TContext
> => {
  const mutationKey = ["setTeacherAssignments"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setTeacherAssignments>>,
    { data: BodyType<SetTeacherAssignmentInput> }
  > = (props) => {
    const { data } = props ?? {};

    return setTeacherAssignments(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetTeacherAssignmentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof setTeacherAssignments>>
>;
export type SetTeacherAssignmentsMutationBody =
  BodyType<SetTeacherAssignmentInput>;
export type SetTeacherAssignmentsMutationError = ErrorType<unknown>;

/**
 * @summary Replace the class assignments for a single teacher
 */
export const useSetTeacherAssignments = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setTeacherAssignments>>,
    TError,
    { data: BodyType<SetTeacherAssignmentInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setTeacherAssignments>>,
  TError,
  { data: BodyType<SetTeacherAssignmentInput> },
  TContext
> => {
  return useMutation(getSetTeacherAssignmentsMutationOptions(options));
};

/**
 * @summary Aggregated school-wide analytics with no teacher attribution
 */
export const getGetSchoolAggregatedAnalyticsUrl = () => {
  return `/api/school/analytics/aggregated`;
};

export const getSchoolAggregatedAnalytics = async (
  options?: RequestInit,
): Promise<SchoolAggregatedAnalytics> => {
  return customFetch<SchoolAggregatedAnalytics>(
    getGetSchoolAggregatedAnalyticsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetSchoolAggregatedAnalyticsQueryKey = () => {
  return [`/api/school/analytics/aggregated`] as const;
};

export const getGetSchoolAggregatedAnalyticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSchoolAggregatedAnalytics>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSchoolAggregatedAnalytics>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSchoolAggregatedAnalyticsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSchoolAggregatedAnalytics>>
  > = ({ signal }) =>
    getSchoolAggregatedAnalytics({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSchoolAggregatedAnalytics>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSchoolAggregatedAnalyticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSchoolAggregatedAnalytics>>
>;
export type GetSchoolAggregatedAnalyticsQueryError = ErrorType<unknown>;

/**
 * @summary Aggregated school-wide analytics with no teacher attribution
 */

export function useGetSchoolAggregatedAnalytics<
  TData = Awaited<ReturnType<typeof getSchoolAggregatedAnalytics>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSchoolAggregatedAnalytics>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSchoolAggregatedAnalyticsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Download all school records as CSV
 */
export const getExportSchoolRecordsCsvUrl = () => {
  return `/api/school/export/csv`;
};

export const exportSchoolRecordsCsv = async (
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getExportSchoolRecordsCsvUrl(), {
    ...options,
    method: "GET",
  });
};

export const getExportSchoolRecordsCsvQueryKey = () => {
  return [`/api/school/export/csv`] as const;
};

export const getExportSchoolRecordsCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof exportSchoolRecordsCsv>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof exportSchoolRecordsCsv>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportSchoolRecordsCsvQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportSchoolRecordsCsv>>
  > = ({ signal }) => exportSchoolRecordsCsv({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportSchoolRecordsCsv>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportSchoolRecordsCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportSchoolRecordsCsv>>
>;
export type ExportSchoolRecordsCsvQueryError = ErrorType<unknown>;

/**
 * @summary Download all school records as CSV
 */

export function useExportSchoolRecordsCsv<
  TData = Awaited<ReturnType<typeof exportSchoolRecordsCsv>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof exportSchoolRecordsCsv>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExportSchoolRecordsCsvQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Suggest matches between the caller's private students and the school roster
 */
export const getGetSchoolMergeSuggestionsUrl = () => {
  return `/api/school/merge-suggestions`;
};

export const getSchoolMergeSuggestions = async (
  options?: RequestInit,
): Promise<MergeSuggestionsResponse> => {
  return customFetch<MergeSuggestionsResponse>(
    getGetSchoolMergeSuggestionsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetSchoolMergeSuggestionsQueryKey = () => {
  return [`/api/school/merge-suggestions`] as const;
};

export const getGetSchoolMergeSuggestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSchoolMergeSuggestions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSchoolMergeSuggestions>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSchoolMergeSuggestionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSchoolMergeSuggestions>>
  > = ({ signal }) => getSchoolMergeSuggestions({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSchoolMergeSuggestions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSchoolMergeSuggestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSchoolMergeSuggestions>>
>;
export type GetSchoolMergeSuggestionsQueryError = ErrorType<unknown>;

/**
 * @summary Suggest matches between the caller's private students and the school roster
 */

export function useGetSchoolMergeSuggestions<
  TData = Awaited<ReturnType<typeof getSchoolMergeSuggestions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSchoolMergeSuggestions>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSchoolMergeSuggestionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Apply confirmed private-to-school student pairs and archive the private records
 */
export const getConfirmSchoolMergeUrl = () => {
  return `/api/school/merge`;
};

export const confirmSchoolMerge = async (
  confirmMergeInput: ConfirmMergeInput,
  options?: RequestInit,
): Promise<SchoolMergeLogEntry> => {
  return customFetch<SchoolMergeLogEntry>(getConfirmSchoolMergeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(confirmMergeInput),
  });
};

export const getConfirmSchoolMergeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmSchoolMerge>>,
    TError,
    { data: BodyType<ConfirmMergeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmSchoolMerge>>,
  TError,
  { data: BodyType<ConfirmMergeInput> },
  TContext
> => {
  const mutationKey = ["confirmSchoolMerge"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmSchoolMerge>>,
    { data: BodyType<ConfirmMergeInput> }
  > = (props) => {
    const { data } = props ?? {};

    return confirmSchoolMerge(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmSchoolMergeMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmSchoolMerge>>
>;
export type ConfirmSchoolMergeMutationBody = BodyType<ConfirmMergeInput>;
export type ConfirmSchoolMergeMutationError = ErrorType<unknown>;

/**
 * @summary Apply confirmed private-to-school student pairs and archive the private records
 */
export const useConfirmSchoolMerge = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmSchoolMerge>>,
    TError,
    { data: BodyType<ConfirmMergeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmSchoolMerge>>,
  TError,
  { data: BodyType<ConfirmMergeInput> },
  TContext
> => {
  return useMutation(getConfirmSchoolMergeMutationOptions(options));
};

/**
 * @summary List merge log entries from the last 48 hours that can still be undone
 */
export const getListSchoolMergeLogUrl = () => {
  return `/api/school/merge/log`;
};

export const listSchoolMergeLog = async (
  options?: RequestInit,
): Promise<SchoolMergeLogEntry[]> => {
  return customFetch<SchoolMergeLogEntry[]>(getListSchoolMergeLogUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSchoolMergeLogQueryKey = () => {
  return [`/api/school/merge/log`] as const;
};

export const getListSchoolMergeLogQueryOptions = <
  TData = Awaited<ReturnType<typeof listSchoolMergeLog>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listSchoolMergeLog>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSchoolMergeLogQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSchoolMergeLog>>
  > = ({ signal }) => listSchoolMergeLog({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSchoolMergeLog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSchoolMergeLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSchoolMergeLog>>
>;
export type ListSchoolMergeLogQueryError = ErrorType<unknown>;

/**
 * @summary List merge log entries from the last 48 hours that can still be undone
 */

export function useListSchoolMergeLog<
  TData = Awaited<ReturnType<typeof listSchoolMergeLog>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listSchoolMergeLog>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSchoolMergeLogQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Two modes:
- Omit `privateStudentId` to revert every still-active pair on this
  entry (legacy behaviour).
- Pass `privateStudentId` to revert ONLY that single pair (per-link
  undo). The pair is marked undone in the entry's pairs JSONB; the
  top-level `undone` flag only flips true once every pair on the
  entry has been undone.

 * @summary Reverse a merge log entry within 48 hours of creation
 */
export const getUndoSchoolMergeUrl = () => {
  return `/api/school/merge/undo`;
};

export const undoSchoolMerge = async (
  undoSchoolMergeBody: UndoSchoolMergeBody,
  options?: RequestInit,
): Promise<SchoolMergeLogEntry> => {
  return customFetch<SchoolMergeLogEntry>(getUndoSchoolMergeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(undoSchoolMergeBody),
  });
};

export const getUndoSchoolMergeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof undoSchoolMerge>>,
    TError,
    { data: BodyType<UndoSchoolMergeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof undoSchoolMerge>>,
  TError,
  { data: BodyType<UndoSchoolMergeBody> },
  TContext
> => {
  const mutationKey = ["undoSchoolMerge"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof undoSchoolMerge>>,
    { data: BodyType<UndoSchoolMergeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return undoSchoolMerge(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UndoSchoolMergeMutationResult = NonNullable<
  Awaited<ReturnType<typeof undoSchoolMerge>>
>;
export type UndoSchoolMergeMutationBody = BodyType<UndoSchoolMergeBody>;
export type UndoSchoolMergeMutationError = ErrorType<unknown>;

/**
 * @summary Reverse a merge log entry within 48 hours of creation
 */
export const useUndoSchoolMerge = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof undoSchoolMerge>>,
    TError,
    { data: BodyType<UndoSchoolMergeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof undoSchoolMerge>>,
  TError,
  { data: BodyType<UndoSchoolMergeBody> },
  TContext
> => {
  return useMutation(getUndoSchoolMergeMutationOptions(options));
};

/**
 * @summary List all staff groups for the head teacher's school
 */
export const getListSchoolGroupsUrl = () => {
  return `/api/school/groups`;
};

export const listSchoolGroups = async (
  options?: RequestInit,
): Promise<SchoolGroup[]> => {
  return customFetch<SchoolGroup[]>(getListSchoolGroupsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSchoolGroupsQueryKey = () => {
  return [`/api/school/groups`] as const;
};

export const getListSchoolGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSchoolGroups>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listSchoolGroups>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSchoolGroupsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSchoolGroups>>
  > = ({ signal }) => listSchoolGroups({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSchoolGroups>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSchoolGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSchoolGroups>>
>;
export type ListSchoolGroupsQueryError = ErrorType<unknown>;

/**
 * @summary List all staff groups for the head teacher's school
 */

export function useListSchoolGroups<
  TData = Awaited<ReturnType<typeof listSchoolGroups>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listSchoolGroups>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSchoolGroupsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a staff group
 */
export const getCreateSchoolGroupUrl = () => {
  return `/api/school/groups`;
};

export const createSchoolGroup = async (
  createSchoolGroupInput: CreateSchoolGroupInput,
  options?: RequestInit,
): Promise<SchoolGroup> => {
  return customFetch<SchoolGroup>(getCreateSchoolGroupUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSchoolGroupInput),
  });
};

export const getCreateSchoolGroupMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSchoolGroup>>,
    TError,
    { data: BodyType<CreateSchoolGroupInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSchoolGroup>>,
  TError,
  { data: BodyType<CreateSchoolGroupInput> },
  TContext
> => {
  const mutationKey = ["createSchoolGroup"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSchoolGroup>>,
    { data: BodyType<CreateSchoolGroupInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createSchoolGroup(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSchoolGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSchoolGroup>>
>;
export type CreateSchoolGroupMutationBody = BodyType<CreateSchoolGroupInput>;
export type CreateSchoolGroupMutationError = ErrorType<unknown>;

/**
 * @summary Create a staff group
 */
export const useCreateSchoolGroup = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSchoolGroup>>,
    TError,
    { data: BodyType<CreateSchoolGroupInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSchoolGroup>>,
  TError,
  { data: BodyType<CreateSchoolGroupInput> },
  TContext
> => {
  return useMutation(getCreateSchoolGroupMutationOptions(options));
};

/**
 * @summary Update a staff group
 */
export const getUpdateSchoolGroupUrl = (groupId: number) => {
  return `/api/school/groups/${groupId}`;
};

export const updateSchoolGroup = async (
  groupId: number,
  updateSchoolGroupInput: UpdateSchoolGroupInput,
  options?: RequestInit,
): Promise<SchoolGroup> => {
  return customFetch<SchoolGroup>(getUpdateSchoolGroupUrl(groupId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSchoolGroupInput),
  });
};

export const getUpdateSchoolGroupMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSchoolGroup>>,
    TError,
    { groupId: number; data: BodyType<UpdateSchoolGroupInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSchoolGroup>>,
  TError,
  { groupId: number; data: BodyType<UpdateSchoolGroupInput> },
  TContext
> => {
  const mutationKey = ["updateSchoolGroup"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSchoolGroup>>,
    { groupId: number; data: BodyType<UpdateSchoolGroupInput> }
  > = (props) => {
    const { groupId, data } = props ?? {};

    return updateSchoolGroup(groupId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSchoolGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSchoolGroup>>
>;
export type UpdateSchoolGroupMutationBody = BodyType<UpdateSchoolGroupInput>;
export type UpdateSchoolGroupMutationError = ErrorType<unknown>;

/**
 * @summary Update a staff group
 */
export const useUpdateSchoolGroup = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSchoolGroup>>,
    TError,
    { groupId: number; data: BodyType<UpdateSchoolGroupInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSchoolGroup>>,
  TError,
  { groupId: number; data: BodyType<UpdateSchoolGroupInput> },
  TContext
> => {
  return useMutation(getUpdateSchoolGroupMutationOptions(options));
};

/**
 * @summary Delete a staff group and its memberships
 */
export const getDeleteSchoolGroupUrl = (groupId: number) => {
  return `/api/school/groups/${groupId}`;
};

export const deleteSchoolGroup = async (
  groupId: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getDeleteSchoolGroupUrl(groupId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSchoolGroupMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSchoolGroup>>,
    TError,
    { groupId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSchoolGroup>>,
  TError,
  { groupId: number },
  TContext
> => {
  const mutationKey = ["deleteSchoolGroup"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSchoolGroup>>,
    { groupId: number }
  > = (props) => {
    const { groupId } = props ?? {};

    return deleteSchoolGroup(groupId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSchoolGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSchoolGroup>>
>;

export type DeleteSchoolGroupMutationError = ErrorType<unknown>;

/**
 * @summary Delete a staff group and its memberships
 */
export const useDeleteSchoolGroup = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSchoolGroup>>,
    TError,
    { groupId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSchoolGroup>>,
  TError,
  { groupId: number },
  TContext
> => {
  return useMutation(getDeleteSchoolGroupMutationOptions(options));
};

/**
 * @summary Replace the membership list for a group
 */
export const getSetSchoolGroupMembersUrl = (groupId: number) => {
  return `/api/school/groups/${groupId}/members`;
};

export const setSchoolGroupMembers = async (
  groupId: number,
  setSchoolGroupMembersInput: SetSchoolGroupMembersInput,
  options?: RequestInit,
): Promise<SchoolGroupMembersResult> => {
  return customFetch<SchoolGroupMembersResult>(
    getSetSchoolGroupMembersUrl(groupId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(setSchoolGroupMembersInput),
    },
  );
};

export const getSetSchoolGroupMembersMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setSchoolGroupMembers>>,
    TError,
    { groupId: number; data: BodyType<SetSchoolGroupMembersInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setSchoolGroupMembers>>,
  TError,
  { groupId: number; data: BodyType<SetSchoolGroupMembersInput> },
  TContext
> => {
  const mutationKey = ["setSchoolGroupMembers"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setSchoolGroupMembers>>,
    { groupId: number; data: BodyType<SetSchoolGroupMembersInput> }
  > = (props) => {
    const { groupId, data } = props ?? {};

    return setSchoolGroupMembers(groupId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetSchoolGroupMembersMutationResult = NonNullable<
  Awaited<ReturnType<typeof setSchoolGroupMembers>>
>;
export type SetSchoolGroupMembersMutationBody =
  BodyType<SetSchoolGroupMembersInput>;
export type SetSchoolGroupMembersMutationError = ErrorType<unknown>;

/**
 * @summary Replace the membership list for a group
 */
export const useSetSchoolGroupMembers = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setSchoolGroupMembers>>,
    TError,
    { groupId: number; data: BodyType<SetSchoolGroupMembersInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setSchoolGroupMembers>>,
  TError,
  { groupId: number; data: BodyType<SetSchoolGroupMembersInput> },
  TContext
> => {
  return useMutation(getSetSchoolGroupMembersMutationOptions(options));
};

/**
 * @summary Current subscription tier, trial status and AI usage
 */
export const getGetSubscriptionTierUrl = () => {
  return `/api/subscription/tier`;
};

export const getSubscriptionTier = async (
  options?: RequestInit,
): Promise<SubscriptionTierInfo> => {
  return customFetch<SubscriptionTierInfo>(getGetSubscriptionTierUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSubscriptionTierQueryKey = () => {
  return [`/api/subscription/tier`] as const;
};

export const getGetSubscriptionTierQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubscriptionTier>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSubscriptionTier>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubscriptionTierQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSubscriptionTier>>
  > = ({ signal }) => getSubscriptionTier({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubscriptionTier>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSubscriptionTierQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSubscriptionTier>>
>;
export type GetSubscriptionTierQueryError = ErrorType<unknown>;

/**
 * @summary Current subscription tier, trial status and AI usage
 */

export function useGetSubscriptionTier<
  TData = Awaited<ReturnType<typeof getSubscriptionTier>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSubscriptionTier>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSubscriptionTierQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List active Stripe products with their prices
 */
export const getListStripeProductsUrl = () => {
  return `/api/stripe/products`;
};

export const listStripeProducts = async (
  options?: RequestInit,
): Promise<StripeProductsResponse> => {
  return customFetch<StripeProductsResponse>(getListStripeProductsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListStripeProductsQueryKey = () => {
  return [`/api/stripe/products`] as const;
};

export const getListStripeProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof listStripeProducts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listStripeProducts>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListStripeProductsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listStripeProducts>>
  > = ({ signal }) => listStripeProducts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listStripeProducts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStripeProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStripeProducts>>
>;
export type ListStripeProductsQueryError = ErrorType<unknown>;

/**
 * @summary List active Stripe products with their prices
 */

export function useListStripeProducts<
  TData = Awaited<ReturnType<typeof listStripeProducts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listStripeProducts>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListStripeProductsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get the current user's Stripe subscription, if any
 */
export const getGetStripeSubscriptionUrl = () => {
  return `/api/stripe/subscription`;
};

export const getStripeSubscription = async (
  options?: RequestInit,
): Promise<StripeSubscriptionResponse> => {
  return customFetch<StripeSubscriptionResponse>(
    getGetStripeSubscriptionUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetStripeSubscriptionQueryKey = () => {
  return [`/api/stripe/subscription`] as const;
};

export const getGetStripeSubscriptionQueryOptions = <
  TData = Awaited<ReturnType<typeof getStripeSubscription>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getStripeSubscription>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStripeSubscriptionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStripeSubscription>>
  > = ({ signal }) => getStripeSubscription({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStripeSubscription>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStripeSubscriptionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStripeSubscription>>
>;
export type GetStripeSubscriptionQueryError = ErrorType<unknown>;

/**
 * @summary Get the current user's Stripe subscription, if any
 */

export function useGetStripeSubscription<
  TData = Awaited<ReturnType<typeof getStripeSubscription>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getStripeSubscription>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStripeSubscriptionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a Stripe Checkout session for the given price
 */
export const getCreateStripeCheckoutSessionUrl = () => {
  return `/api/stripe/checkout`;
};

export const createStripeCheckoutSession = async (
  stripeCheckoutInput: StripeCheckoutInput,
  options?: RequestInit,
): Promise<StripeRedirectUrlResponse> => {
  return customFetch<StripeRedirectUrlResponse>(
    getCreateStripeCheckoutSessionUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(stripeCheckoutInput),
    },
  );
};

export const getCreateStripeCheckoutSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStripeCheckoutSession>>,
    TError,
    { data: BodyType<StripeCheckoutInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStripeCheckoutSession>>,
  TError,
  { data: BodyType<StripeCheckoutInput> },
  TContext
> => {
  const mutationKey = ["createStripeCheckoutSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStripeCheckoutSession>>,
    { data: BodyType<StripeCheckoutInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createStripeCheckoutSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStripeCheckoutSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStripeCheckoutSession>>
>;
export type CreateStripeCheckoutSessionMutationBody =
  BodyType<StripeCheckoutInput>;
export type CreateStripeCheckoutSessionMutationError = ErrorType<unknown>;

/**
 * @summary Create a Stripe Checkout session for the given price
 */
export const useCreateStripeCheckoutSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStripeCheckoutSession>>,
    TError,
    { data: BodyType<StripeCheckoutInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createStripeCheckoutSession>>,
  TError,
  { data: BodyType<StripeCheckoutInput> },
  TContext
> => {
  return useMutation(getCreateStripeCheckoutSessionMutationOptions(options));
};

/**
 * @summary Create a Stripe Billing Portal session
 */
export const getCreateStripePortalSessionUrl = () => {
  return `/api/stripe/portal`;
};

export const createStripePortalSession = async (
  options?: RequestInit,
): Promise<StripeRedirectUrlResponse> => {
  return customFetch<StripeRedirectUrlResponse>(
    getCreateStripePortalSessionUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getCreateStripePortalSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStripePortalSession>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStripePortalSession>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["createStripePortalSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStripePortalSession>>,
    void
  > = () => {
    return createStripePortalSession(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStripePortalSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStripePortalSession>>
>;

export type CreateStripePortalSessionMutationError = ErrorType<unknown>;

/**
 * @summary Create a Stripe Billing Portal session
 */
export const useCreateStripePortalSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStripePortalSession>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createStripePortalSession>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCreateStripePortalSessionMutationOptions(options));
};

/**
 * @summary Convert shorthand notes into professional school-safe documentation
 */
export const getAiPolishTextUrl = () => {
  return `/api/ai/polish`;
};

export const aiPolishText = async (
  aiPolishTextBody: AiPolishTextBody,
  options?: RequestInit,
): Promise<AiPolishText200> => {
  return customFetch<AiPolishText200>(getAiPolishTextUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(aiPolishTextBody),
  });
};

export const getAiPolishTextMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiPolishText>>,
    TError,
    { data: BodyType<AiPolishTextBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof aiPolishText>>,
  TError,
  { data: BodyType<AiPolishTextBody> },
  TContext
> => {
  const mutationKey = ["aiPolishText"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof aiPolishText>>,
    { data: BodyType<AiPolishTextBody> }
  > = (props) => {
    const { data } = props ?? {};

    return aiPolishText(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AiPolishTextMutationResult = NonNullable<
  Awaited<ReturnType<typeof aiPolishText>>
>;
export type AiPolishTextMutationBody = BodyType<AiPolishTextBody>;
export type AiPolishTextMutationError = ErrorType<unknown>;

/**
 * @summary Convert shorthand notes into professional school-safe documentation
 */
export const useAiPolishText = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiPolishText>>,
    TError,
    { data: BodyType<AiPolishTextBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof aiPolishText>>,
  TError,
  { data: BodyType<AiPolishTextBody> },
  TContext
> => {
  return useMutation(getAiPolishTextMutationOptions(options));
};

/**
 * @summary Polish notes into NCCD-compliant prose and detect adjustment IDs
 */
export const getAiNccdPolishTextUrl = () => {
  return `/api/ai/nccd-polish`;
};

export const aiNccdPolishText = async (
  aiNccdPolishTextBody: AiNccdPolishTextBody,
  options?: RequestInit,
): Promise<AiNccdPolishText200> => {
  return customFetch<AiNccdPolishText200>(getAiNccdPolishTextUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(aiNccdPolishTextBody),
  });
};

export const getAiNccdPolishTextMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiNccdPolishText>>,
    TError,
    { data: BodyType<AiNccdPolishTextBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof aiNccdPolishText>>,
  TError,
  { data: BodyType<AiNccdPolishTextBody> },
  TContext
> => {
  const mutationKey = ["aiNccdPolishText"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof aiNccdPolishText>>,
    { data: BodyType<AiNccdPolishTextBody> }
  > = (props) => {
    const { data } = props ?? {};

    return aiNccdPolishText(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AiNccdPolishTextMutationResult = NonNullable<
  Awaited<ReturnType<typeof aiNccdPolishText>>
>;
export type AiNccdPolishTextMutationBody = BodyType<AiNccdPolishTextBody>;
export type AiNccdPolishTextMutationError = ErrorType<unknown>;

/**
 * @summary Polish notes into NCCD-compliant prose and detect adjustment IDs
 */
export const useAiNccdPolishText = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiNccdPolishText>>,
    TError,
    { data: BodyType<AiNccdPolishTextBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof aiNccdPolishText>>,
  TError,
  { data: BodyType<AiNccdPolishTextBody> },
  TContext
> => {
  return useMutation(getAiNccdPolishTextMutationOptions(options));
};

/**
 * @summary Generate per-student lesson preparation suggestions from recent records (Premium)
 */
export const getAiLessonPrepUrl = () => {
  return `/api/ai/lesson-prep`;
};

export const aiLessonPrep = async (
  aiLessonPrepBody: AiLessonPrepBody,
  options?: RequestInit,
): Promise<AiLessonPrep200> => {
  return customFetch<AiLessonPrep200>(getAiLessonPrepUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(aiLessonPrepBody),
  });
};

export const getAiLessonPrepMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiLessonPrep>>,
    TError,
    { data: BodyType<AiLessonPrepBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof aiLessonPrep>>,
  TError,
  { data: BodyType<AiLessonPrepBody> },
  TContext
> => {
  const mutationKey = ["aiLessonPrep"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof aiLessonPrep>>,
    { data: BodyType<AiLessonPrepBody> }
  > = (props) => {
    const { data } = props ?? {};

    return aiLessonPrep(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AiLessonPrepMutationResult = NonNullable<
  Awaited<ReturnType<typeof aiLessonPrep>>
>;
export type AiLessonPrepMutationBody = BodyType<AiLessonPrepBody>;
export type AiLessonPrepMutationError = ErrorType<void>;

/**
 * @summary Generate per-student lesson preparation suggestions from recent records (Premium)
 */
export const useAiLessonPrep = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiLessonPrep>>,
    TError,
    { data: BodyType<AiLessonPrepBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof aiLessonPrep>>,
  TError,
  { data: BodyType<AiLessonPrepBody> },
  TContext
> => {
  return useMutation(getAiLessonPrepMutationOptions(options));
};

/**
 * Stores the teacher's 👍 / 👎 rating for an AI-generated output
in the `ai_feedback` table, linked to the originating
`ai_usage_events` row (one per successful AI call). The
optional `comment` is the one-line "what went wrong?" note
from the thumbs-down textarea; the rating is recorded either
way. The route validates the ai_usage_id belongs to the
requesting teacher.

 * @summary Record a thumbs-up / thumbs-down rating for an AI output (Task
 */
export const getAiFeedbackUrl = () => {
  return `/api/ai/feedback`;
};

export const aiFeedback = async (
  aiFeedbackBody: AiFeedbackBody,
  options?: RequestInit,
): Promise<AiFeedback201> => {
  return customFetch<AiFeedback201>(getAiFeedbackUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(aiFeedbackBody),
  });
};

export const getAiFeedbackMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiFeedback>>,
    TError,
    { data: BodyType<AiFeedbackBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof aiFeedback>>,
  TError,
  { data: BodyType<AiFeedbackBody> },
  TContext
> => {
  const mutationKey = ["aiFeedback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof aiFeedback>>,
    { data: BodyType<AiFeedbackBody> }
  > = (props) => {
    const { data } = props ?? {};

    return aiFeedback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AiFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof aiFeedback>>
>;
export type AiFeedbackMutationBody = BodyType<AiFeedbackBody>;
export type AiFeedbackMutationError = ErrorType<void>;

/**
 * @summary Record a thumbs-up / thumbs-down rating for an AI output (Task
 */
export const useAiFeedback = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiFeedback>>,
    TError,
    { data: BodyType<AiFeedbackBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof aiFeedback>>,
  TError,
  { data: BodyType<AiFeedbackBody> },
  TContext
> => {
  return useMutation(getAiFeedbackMutationOptions(options));
};

/**
 * @summary Get dashboard summary counts and recent activity
 */
export const getGetAnalyticsSummaryUrl = () => {
  return `/api/analytics/summary`;
};

export const getAnalyticsSummary = async (
  options?: RequestInit,
): Promise<AnalyticsSummary> => {
  return customFetch<AnalyticsSummary>(getGetAnalyticsSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAnalyticsSummaryQueryKey = () => {
  return [`/api/analytics/summary`] as const;
};

export const getGetAnalyticsSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAnalyticsSummary>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnalyticsSummary>>
  > = ({ signal }) => getAnalyticsSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnalyticsSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsSummary>>
>;
export type GetAnalyticsSummaryQueryError = ErrorType<unknown>;

/**
 * @summary Get dashboard summary counts and recent activity
 */

export function useGetAnalyticsSummary<
  TData = Awaited<ReturnType<typeof getAnalyticsSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAnalyticsSummary>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAnalyticsSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get record counts and trends for a student
 */
export const getGetStudentAnalyticsUrl = (studentId: number) => {
  return `/api/analytics/students/${studentId}`;
};

export const getStudentAnalytics = async (
  studentId: number,
  options?: RequestInit,
): Promise<StudentAnalytics> => {
  return customFetch<StudentAnalytics>(getGetStudentAnalyticsUrl(studentId), {
    ...options,
    method: "GET",
  });
};

export const getGetStudentAnalyticsQueryKey = (studentId: number) => {
  return [`/api/analytics/students/${studentId}`] as const;
};

export const getGetStudentAnalyticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentAnalytics>>,
  TError = ErrorType<unknown>,
>(
  studentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAnalytics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStudentAnalyticsQueryKey(studentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentAnalytics>>
  > = ({ signal }) =>
    getStudentAnalytics(studentId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!studentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentAnalytics>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStudentAnalyticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentAnalytics>>
>;
export type GetStudentAnalyticsQueryError = ErrorType<unknown>;

/**
 * @summary Get record counts and trends for a student
 */

export function useGetStudentAnalytics<
  TData = Awaited<ReturnType<typeof getStudentAnalytics>>,
  TError = ErrorType<unknown>,
>(
  studentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAnalytics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStudentAnalyticsQueryOptions(studentId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get pattern reports (by period, class, note type, frequency)
 */
export const getGetPatternsUrl = (params?: GetPatternsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/analytics/patterns?${stringifiedParams}`
    : `/api/analytics/patterns`;
};

export const getPatterns = async (
  params?: GetPatternsParams,
  options?: RequestInit,
): Promise<PatternsReport> => {
  return customFetch<PatternsReport>(getGetPatternsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetPatternsQueryKey = (params?: GetPatternsParams) => {
  return [`/api/analytics/patterns`, ...(params ? [params] : [])] as const;
};

export const getGetPatternsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatterns>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPatternsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPatterns>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatternsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatterns>>> = ({
    signal,
  }) => getPatterns(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatterns>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPatternsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatterns>>
>;
export type GetPatternsQueryError = ErrorType<unknown>;

/**
 * @summary Get pattern reports (by period, class, note type, frequency)
 */

export function useGetPatterns<
  TData = Awaited<ReturnType<typeof getPatterns>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPatternsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPatterns>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPatternsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Request a presigned URL for file upload
 */
export const getRequestUploadUrlUrl = () => {
  return `/api/storage/uploads/request-url`;
};

export const requestUploadUrl = async (
  uploadUrlRequest: UploadUrlRequest,
  options?: RequestInit,
): Promise<UploadUrlResponse> => {
  return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(uploadUrlRequest),
  });
};

export const getRequestUploadUrlMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  const mutationKey = ["requestUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    { data: BodyType<UploadUrlRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return requestUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestUploadUrl>>
>;
export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>;
export type RequestUploadUrlMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  return useMutation(getRequestUploadUrlMutationOptions(options));
};

/**
 * Soft-deletes the caller's account: sets `profiles.deleted_at` +
`deletion_requested_at`, writes an audit row, cancels any
active Stripe subscription at period end, revokes all Clerk
sessions and bans the Clerk user. The 30-day purge cron then
hard-deletes the account on schedule.

Idempotent — calling it on an account already in the deletion
window returns 200 with the existing timestamps.

 * @summary Request account deletion (Task
 */
export const getDeleteProfileUrl = () => {
  return `/api/profile/delete`;
};

export const deleteProfile = async (
  deleteProfileBody?: DeleteProfileBody,
  options?: RequestInit,
): Promise<DeleteProfile200> => {
  return customFetch<DeleteProfile200>(getDeleteProfileUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(deleteProfileBody),
  });
};

export const getDeleteProfileMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProfile>>,
    TError,
    { data: BodyType<DeleteProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProfile>>,
  TError,
  { data: BodyType<DeleteProfileBody> },
  TContext
> => {
  const mutationKey = ["deleteProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProfile>>,
    { data: BodyType<DeleteProfileBody> }
  > = (props) => {
    const { data } = props ?? {};

    return deleteProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProfile>>
>;
export type DeleteProfileMutationBody = BodyType<DeleteProfileBody>;
export type DeleteProfileMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Request account deletion (Task
 */
export const useDeleteProfile = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProfile>>,
    TError,
    { data: BodyType<DeleteProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteProfile>>,
  TError,
  { data: BodyType<DeleteProfileBody> },
  TContext
> => {
  return useMutation(getDeleteProfileMutationOptions(options));
};

/**
 * @summary Restore a soft-deleted account within the 30-day window (admin only)
 */
export const getRestoreAccountUrl = () => {
  return `/api/admin/restore-account`;
};

export const restoreAccount = async (
  restoreAccountBody: RestoreAccountBody,
  options?: RequestInit,
): Promise<RestoreAccount200> => {
  return customFetch<RestoreAccount200>(getRestoreAccountUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(restoreAccountBody),
  });
};

export const getRestoreAccountMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreAccount>>,
    TError,
    { data: BodyType<RestoreAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreAccount>>,
  TError,
  { data: BodyType<RestoreAccountBody> },
  TContext
> => {
  const mutationKey = ["restoreAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreAccount>>,
    { data: BodyType<RestoreAccountBody> }
  > = (props) => {
    const { data } = props ?? {};

    return restoreAccount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreAccount>>
>;
export type RestoreAccountMutationBody = BodyType<RestoreAccountBody>;
export type RestoreAccountMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Restore a soft-deleted account within the 30-day window (admin only)
 */
export const useRestoreAccount = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreAccount>>,
    TError,
    { data: BodyType<RestoreAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof restoreAccount>>,
  TError,
  { data: BodyType<RestoreAccountBody> },
  TContext
> => {
  return useMutation(getRestoreAccountMutationOptions(options));
};

/**
 * @summary Create or update a school code (admin only)
 */
export const getUpsertSchoolCodeUrl = () => {
  return `/api/admin/school-codes`;
};

export const upsertSchoolCode = async (
  upsertSchoolCodeInput: UpsertSchoolCodeInput,
  options?: RequestInit,
): Promise<UpsertSchoolCode200> => {
  return customFetch<UpsertSchoolCode200>(getUpsertSchoolCodeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(upsertSchoolCodeInput),
  });
};

export const getUpsertSchoolCodeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertSchoolCode>>,
    TError,
    { data: BodyType<UpsertSchoolCodeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertSchoolCode>>,
  TError,
  { data: BodyType<UpsertSchoolCodeInput> },
  TContext
> => {
  const mutationKey = ["upsertSchoolCode"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertSchoolCode>>,
    { data: BodyType<UpsertSchoolCodeInput> }
  > = (props) => {
    const { data } = props ?? {};

    return upsertSchoolCode(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertSchoolCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertSchoolCode>>
>;
export type UpsertSchoolCodeMutationBody = BodyType<UpsertSchoolCodeInput>;
export type UpsertSchoolCodeMutationError = ErrorType<unknown>;

/**
 * @summary Create or update a school code (admin only)
 */
export const useUpsertSchoolCode = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertSchoolCode>>,
    TError,
    { data: BodyType<UpsertSchoolCodeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertSchoolCode>>,
  TError,
  { data: BodyType<UpsertSchoolCodeInput> },
  TContext
> => {
  return useMutation(getUpsertSchoolCodeMutationOptions(options));
};

/**
 * @summary Delete a school code (admin only)
 */
export const getDeleteSchoolCodeUrl = (schoolCode: string) => {
  return `/api/admin/school-codes/${schoolCode}`;
};

export const deleteSchoolCode = async (
  schoolCode: string,
  options?: RequestInit,
): Promise<DeleteSchoolCode200> => {
  return customFetch<DeleteSchoolCode200>(getDeleteSchoolCodeUrl(schoolCode), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSchoolCodeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSchoolCode>>,
    TError,
    { schoolCode: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSchoolCode>>,
  TError,
  { schoolCode: string },
  TContext
> => {
  const mutationKey = ["deleteSchoolCode"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSchoolCode>>,
    { schoolCode: string }
  > = (props) => {
    const { schoolCode } = props ?? {};

    return deleteSchoolCode(schoolCode, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSchoolCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSchoolCode>>
>;

export type DeleteSchoolCodeMutationError = ErrorType<unknown>;

/**
 * @summary Delete a school code (admin only)
 */
export const useDeleteSchoolCode = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSchoolCode>>,
    TError,
    { schoolCode: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSchoolCode>>,
  TError,
  { schoolCode: string },
  TContext
> => {
  return useMutation(getDeleteSchoolCodeMutationOptions(options));
};

/**
 * @summary Delete a user (admin only)
 */
export const getDeleteAdminUserUrl = (userId: string) => {
  return `/api/admin/users/${userId}`;
};

export const deleteAdminUser = async (
  userId: string,
  options?: RequestInit,
): Promise<DeleteAdminUser200> => {
  return customFetch<DeleteAdminUser200>(getDeleteAdminUserUrl(userId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAdminUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminUser>>,
    TError,
    { userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminUser>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ["deleteAdminUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminUser>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return deleteAdminUser(userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminUser>>
>;

export type DeleteAdminUserMutationError = ErrorType<unknown>;

/**
 * @summary Delete a user (admin only)
 */
export const useDeleteAdminUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminUser>>,
    TError,
    { userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminUser>>,
  TError,
  { userId: string },
  TContext
> => {
  return useMutation(getDeleteAdminUserMutationOptions(options));
};

/**
 * @summary Serve a stored object
 */
export const getGetStorageObjectUrl = (objectPath: string) => {
  return `/api/storage/objects/${objectPath}`;
};

export const getStorageObject = async (
  objectPath: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetStorageObjectUrl(objectPath), {
    ...options,
    method: "GET",
  });
};

export const getGetStorageObjectQueryKey = (objectPath: string) => {
  return [`/api/storage/objects/${objectPath}`] as const;
};

export const getGetStorageObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  objectPath: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStorageObject>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStorageObject>>
  > = ({ signal }) =>
    getStorageObject(objectPath, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!objectPath,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorageObject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStorageObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStorageObject>>
>;
export type GetStorageObjectQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Serve a stored object
 */

export function useGetStorageObject<
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  objectPath: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStorageObject>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStorageObjectQueryOptions(objectPath, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}
